import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import '../../css/home/home.css';
import ColorsMain from '../../colors/ColorsMain';
import StepProgress from '../../components/Steps/StepProgress';
import NavbarRegistro from '../../components/navbar/NavbarRegistro';
import Step1 from '../../components/layouts/documentationLegal/Step1';
import Step2 from '../../components/layouts/documentationLegal/Step2';
import Step3 from '../../components/layouts/documentationLegal/Step3';
import Step4 from '../../components/layouts/documentationLegal/Step4';
import Step5 from '../../components/layouts/documentationLegal/Step5';
import Step6 from '../../components/layouts/documentationLegal/Step6';
import Step7 from '../../components/layouts/documentationLegal/Step7';
import { AuthContext } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { getHashKey } from '../../functions/createSignImages';
import ModalAlert from '../../components/modal/ModalAlert'
import { motion } from 'framer-motion';
import { validateEmail } from '../../utils/VaidateEmail'

import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";
import { Menu } from 'lucide-react';




const DocumentationLegal = () => {

    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || 'es'
    const [timer, setTimer] = useState(45); // Temporizador inicial de 45 segundos
    const [isDisabled, setIsDisabled] = useState(false);
    const [isRefreshed, setIsRefreshed] = useState(false);
    const [LoadingLayouts, setLoadingLayouts] = useState(true);
    const [ProgressStep, setProgressStep] = useState("");


    const [hasPermission, setHasPermission] = useState(null); // null, true, false
    const videoRef = useRef(null);
    const location = useLocation();
    const { companyName, activityFinal, ServiceColursFinal, data, step } = location.state || {};

    const savedPaso = localStorage.getItem("paso");
    console.log(savedPaso);
    const DetailUser = JSON.parse(localStorage.getItem('userDetails'));
    const navigate = useNavigate();

    const [paso, setPaso] = useState(() => {
        const savedPaso = localStorage.getItem("paso");
        return savedPaso ? JSON.parse(savedPaso) : step ? step : 1;


    });
    const [AnimationBack, setAnimationBack] = useState(false);
    const [ListaState, setListState] = useState([]);

    const [LoadingBenefactores, setLoadingBenefactores] = useState(true);
    const [LoadingBack, setLoadingBack] = useState(false);


    const [title, setTitle] = useState("");
    const [description, setDescripcion] = useState("");
    const [labelModalWhite, setLabelModalWhite] = useState("");
    const [becomeData, setBecomeData] = useState({});
    const [ErrorCompany, setErrorCompany] = useState(false);
    const [CambioDocument, setCambioDocument] = useState({});
    const [DataOnboarding, setDataOnboarding] = useState(null);
    const [listCities, setListCities] = useState([]);




    const [DataCompany, setDataCompany] = useState(null);
    const [LoadingKYC, setLoadingKYC] = useState(true);


    const [LevelKYC, setLevelKYC] = useState(null);
    const [LevelKYCError, setLevelKYCError] = useState(null);
    const [LevelKYCReadOnly, setLevelKYCReadOnly] = useState(null);

    const [error, setError] = useState(false)
    const [errorMesagge, setErrorMesagge] = useState(false)
    //paso 1 variables
    const [enterPriseName, setEnterpriseName] = useState(companyName);
    const [interestedServices, setInterestedServices] = useState(ServiceColursFinal);
    const [businessActivities, setBusinessActivities] = useState(activityFinal);

    const [enterpriseLegaName, setEnterPriseLegaName] = useState(null);
    const [enterpriseLegaNameError, setEnterPriseLegaNameError] = useState(false);
    const [enterpriseLegaNameReadOnly, setEnterPriseLegaNameReadOnly] = useState(false);

    const [isCompanyPrivate, setIsCompanyPrivate] = useState(true);
    const [isCompanyPrivateError, setIsCompanyPrivateError] = useState(false);
    const [isCompanyPrivateReadOnly, setIsCompanyPrivateReadOnly] = useState(false);


    const [enterpriseIdentification, setEnterpriseIdentification] = useState(null);
    const [enterpriseIdentificationError, setEnterpriseIdentificationError] = useState(false);
    const [enterpriseIdentificationReadOnly, setEnterpriseIdentificationReadOnly] = useState(false);

    const [creationDate, setCreationDate] = useState(null);
    const [creationDateError, setCreationDateError] = useState(false);
    const [creationDateReadOnly, setCreationDateReadOnly] = useState(false);

    const [countryRegistered, setCountryRegistered] = useState(language == "es" ? "CO" : "US");
    const [countryRegisteredError, setCountryRegisteredError] = useState(false);
    const [countryRegisteredReadOnly, setCountryRegisteredReadOnly] = useState(false);

    const [website, setWebsite] = useState(null);
    const [websiteError, setWebsiteError] = useState(false);
    const [websiteReadOnly, setWebsiteReadOnly] = useState(false);

    const [city, setCity] = useState(null);
    const [cityError, setCityError] = useState(false);
    const [cityReadOnly, setCityReadOnly] = useState(false);

    const [countryState, setCountryState] = useState(null);
    const [countryStateError, setCountryStateError] = useState(false);
    const [countryStateReadOnly, setCountryStaterReadOnly] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState(null);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [phoneNumberReadOnly, setPhoneNumberReadOnly] = useState(false);

    const [phoneNumberCode, setPhoneNumberCode] = useState(language == "es" ? '+57' : "+1");
    const [phoneNumberCodeError, setPhoneNumberCodeError] = useState(false);
    const [phoneNumberCodeReadOnly, setPhoneNumberCodeReadOnly] = useState(false);

    const [address, setAddress] = useState(null);
    const [addressError, setAddressError] = useState(false);
    const [addressReadOnly, setAddressReadOnly] = useState(false);

    const [enterpriseDescription, setEnterpriseDescription] = useState(null);
    const [enterpriseDescriptionError, setEnterpriseDescriptionError] = useState(false);
    const [enterpriseDescriptionReadOnly, setEnterpriseDescriptionReadOnly] = useState(false);

    const [ArhivoSociedad, setArhivoSociedad] = useState(null);
    const [ArhivoSociedadError, setArhivoSociedadError] = useState(false);
    const [ArhivoSociedadReadOnly, setArhivoSociedadReadOnly] = useState(false);


    const [ArhivoTributario, setArhivoTributario] = useState(null);
    const [ArhivoTributarioError, setArhivoTributarioError] = useState(false);
    const [ArhivoTributarioReadOnly, setArhivoTributarioReadOnly] = useState(false);


    const [ArhivoMercantil, setArhivoMercantil] = useState(null);
    const [ArhivoMercantilError, setArhivoMercantilError] = useState(false);
    const [ArhivoMercantilReadOnly, setArhivoMercantilReadOnly] = useState(false);


    const [ArhivoBrochure, setArhivoBrochure] = useState(null);
    const [ArhivoBrochureError, setArhivoBrochureError] = useState(false);
    const [ArhivoBrochureReadOnly, setArhivoBrochureReadOnly] = useState(false);


    const [documents_step_1, setDocuments_step_1] = useState(null);
    const [documents_step_1Error, setDocuments_step_1Error] = useState(false);
    const [documents_step_1ReadOnly, setDocuments_step_1ReadOnly] = useState(false);





    //paso 2 variables
    const [categoryId, setCategoryId] = useState(null);
    const [categoryIdError, setCategoryIdError] = useState(false);
    const [categoryIdReadOnly, setCategoryIdReadOnly] = useState(false);

    const [categoryDescription, setCategoryDescription] = useState(null);
    const [categoryDescriptionError, setCategoryDescriptionError] = useState(false);
    const [categoryDescriptionReadOnly, setCategoryDescriptionReadOnly] = useState(false);

    const [monthlyIncomeId, setMonthlyIncomeId] = useState(null);
    const [monthlyIncomeIdError, setMonthlyIncomeIdError] = useState(false);
    const [monthlyIncomeIdReadOnly, setMonthlyIncomeIdReadOnly] = useState(false);

    const [monthlyExpensesId, setMonthlyExpensesId] = useState(null);
    const [monthlyExpensesIdError, setMonthlyExpensesIdError] = useState(false);
    const [monthlyExpensesIdReadOnly, setMonthlyExpensesIdReadOnly] = useState(false);

    const [totalAssetId, setTotalAssetId] = useState(null);
    const [totalAssetIdError, setTotalAssetIdError] = useState(false);
    const [totalAssetIdReadOnly, setTotalAssetIdReadOnly] = useState(false);

    const [totalLiabilityId, setTotalLiabilityId] = useState(null);
    const [totalLiabilityIdError, setTotalLiabilityIdError] = useState(false);
    const [totalLiabilityIdReadOnly, setTotalLiabilityIdReadOnly] = useState(false);

    const [totalEquityId, setTotalEquityId] = useState(null);
    const [totalEquityIdError, setTotalEquityIdError] = useState(false);
    const [totalEquityIdReadOnly, setTotalEquityIdReadOnly] = useState(false);

    const [taxCountry, setTaxCountry] = useState(null);
    const [taxCountryError, setTaxCountryError] = useState(false);
    const [taxCountryReadOnly, setTaxCountryReadOnly] = useState(false);

    const [haveOtherIncome, seThaveOtherIncome] = useState(false);
    const [haveOtherIncomeError, seThaveOtherIncomeError] = useState(false);
    const [haveOtherIncomeReadOnly, seThaveOtherIncomeReadOnly] = useState(false);

    const [otherIncomeDescription, setOtherIncomeDescription] = useState(null);
    const [otherIncomeDescriptionError, setOtherIncomeDescriptionError] = useState(false);
    const [otherIncomeDescriptionReadOnly, setOtherIncomeDescriptionReadOnly] = useState(false);

    const [otherIncomeId, setotherIncomeId] = useState(null);
    const [otherIncomeIdError, setotherIncomeIdError] = useState(false);
    const [otherIncomeIdReadOnly, setotherIncomeIdReadOnly] = useState(false);

    const [haveInternationalTransaction, sethaveInternationalTransaction] = useState(false);
    const [haveInternationalTransactionError, sethaveInternationalTransactionError] = useState(false);
    const [haveInternationalTransactionReadOnly, sethaveInternationalTransactionReadOnly] = useState(false);

    const [DocyearStatus, setDocyearStatus] = useState(null);
    const [DocyearStatusError, setDocyearStatusError] = useState(false);
    const [DocyearStatusReadOnly, setDocyearStatusReadOnly] = useState(false);

    const [haveInternationalTransactionCountry, sethaveInternationalTransactionCountry] = useState(null);
    const [haveInternationalTransactionCountryError, sethaveInternationalTransactionCountryError] = useState(false);
    const [haveInternationalTransactionCountryReadOnly, sethaveInternationalTransactionCountryReadOnly] = useState(false);

    const [haveInternationalTransactionNumber, sethaveInternationalTransactionNumber] = useState(null);
    const [haveInternationalTransactionNumberError, sethaveInternationalTransactionNumberError] = useState(false);
    const [haveInternationalTransactionNumberReadOnly, sethaveInternationalTransactionNumberReadOnly] = useState(false);

    const [haveInternationalTransactionEntidad, sethaveInternationalTransactionEntidad] = useState(null);
    const [haveInternationalTransactionEntidadError, sethaveInternationalTransactionEntidadError] = useState(false);
    const [haveInternationalTransactionEntidadReadOnly, sethaveInternationalTransactionEntidadReadOnly] = useState(false);

    const [haveInternationalTransactionRango, sethaveInternationalTransactionRango] = useState(null);
    const [haveInternationalTransactionRangoError, sethaveInternationalTransactionRangoError] = useState(false);
    const [haveInternationalTransactionRangoReadOnly, sethaveInternationalTransactionRangoReadOnly] = useState(false);

    const [haveAml, sethaveAml] = useState(false);
    const [haveAmlError, sethaveAmlError] = useState(false);
    const [haveAmlReadOnly, sethaveAmlReadOnly] = useState(false);

    const [byLicensed, setByLicensed] = useState(false);
    const [byLicensedError, setByLicensedError] = useState(false);
    const [byLicensedReadOnly, setByLicensedReadOnly] = useState(false);

    const [byLicensedDoc, setByLicensedDoc] = useState(null);
    const [byLicensedDocError, setByLicensedDocError] = useState(false);
    const [byLicensedDocReadOnly, setByLicensedDocReadOnly] = useState(false);

    const [haveComplianceOfficer, sethaveComplianceOfficer] = useState(false);
    const [haveComplianceOfficerError, sethaveComplianceOfficerError] = useState(false);
    const [haveComplianceOfficerReadOnly, sethaveComplianceOfficerReadOnly] = useState(false);

    const [haveVirtualAsset, sethaveVirtualAsset] = useState(false);
    const [haveVirtualAssetError, sethaveVirtualAssetError] = useState(false);
    const [haveVirtualAssetReadOnly, sethaveVirtualAssetReadOnly] = useState(false);

    const [internationalTransactions, setinternationalTransactions] = useState(null);
    const [internationalTransactionsError, setinternationalTransactionsError] = useState(false);
    const [internationalTransactionsReadOnly, setinternationalTransactionsReadOnly] = useState(false);

    const [documentsStep2, setdocumentsStep2] = useState(null);
    const [documentsStep2Error, setdocumentsStep2Error] = useState(false);
    const [documentsStep2ReadOnly, setdocumentsStep2ReadOnly] = useState(false);






    //paso 3 variables
    const [documentTypeLegal, setdocumentTypeLegal] = useState(null);
    const [documentTypeLegalError, setdocumentTypeLegalError] = useState(false);
    const [documentTypeLegalReadOnly, setdocumentTypeLegalReadOnly] = useState(false);




    const [documentNumberLegal, setdocumentNumberLegal] = useState(null);
    const [documentNumberLegalError, setdocumentNumberLegalError] = useState(false);
    const [documentNumberLegalReadOnly, setdocumentNumberLegalReadOnly] = useState(false);

    const [nameLegal, setameLegal] = useState(null);
    const [nameLegalError, setnameLegalError] = useState(false);
    const [nameLegalReadOnly, setnameLegalReadOnly] = useState(false);

    const [lastNameLegal, setlastNameLegal] = useState(null);
    const [lastNameLegalError, setlastNameLegalError] = useState(false);
    const [lastNameLegalReadOnly, setlastNameLegalReadOnly] = useState(false);

    const [countryLegalName, setcountryLegalName] = useState(null);
    const [countryLegalNameError, setcountryLegalNameError] = useState(false);
    const [countryLegalNameReadOnly, setcountryLegalNameReadOnly] = useState(false);

    const [domicileState, setdomicileState] = useState(null);
    const [domicileStateError, setdomicileStateError] = useState(false);
    const [domicileStateReadOnly, setdomicileStateReadOnly] = useState(false);

    const [domicileCity, setdomicileCity] = useState(null);
    const [domicileCityError, setdomicileCityError] = useState(false);
    const [domicileCityReadOnly, setdomicileCityReadOnly] = useState(false);

    const [domicileAddress, setdomicileAddress] = useState(null);
    const [domicileAddressError, setdomicileAddressError] = useState(false);
    const [domicileAddressReadOnly, setdomicileAddressReadOnly] = useState(false);

    const [domicileDetail, setdomicileDetail] = useState(null);
    const [domicileDetailError, setdomicileDetailError] = useState(false);
    const [domicileDetailReadOnly, setdomicileDetailReadOnly] = useState(false);

    const [emailLegalAgent, setemailLegalAgent] = useState(null);
    const [emailLegalAgentError, setemailLegalAgentError] = useState(false);
    const [emailLegalAgentReadOnly, setemailLegalAgentReadOnly] = useState(false);

    const [phoneLegalAgent, setphoneLegalAgent] = useState(null);
    const [phoneLegalAgentError, setphoneLegalAgentError] = useState(false);
    const [phoneLegalAgentReadOnly, setphoneLegalAgentReadOnly] = useState(false);

    const [phoneLegalAgentCode, setphoneLegalAgentCode] = useState(language == "es" ? "+57" : "+1");
    const [phoneLegalAgentCodeError, setphoneLegalAgentCodeError] = useState(false);
    const [phoneLegalAgentCodeReadOnly, setphoneLegalAgentCodeReadOnly] = useState(false);


    const [documentPP, setdocumentPP] = useState(null);
    const [documentPPError, setdocumentPPError] = useState(false);
    const [documentPPReadOnly, setdocumentPPReadOnly] = useState(false);


    const [isPep, setisPep] = useState(false);
    const [isPepError, setisPepError] = useState(false);
    const [isPepReadOnly, setisPepReadOnly] = useState(false);

    const [publicCharge, setpublicCharge] = useState("");
    const [publicChargeError, setpublicChargeError] = useState(false);
    const [publicChargeReadOnly, setpublicChargeReadOnly] = useState(false);

    const [detailCharge, setdetailCharge] = useState(null);
    const [detailChargeError, setdetailChargeError] = useState(false);
    const [detailChargeReadOnly, setdetailChargeReadOnly] = useState(false);

    const [managepublicResource, setmanagepublicResource] = useState(false);
    const [managepublicResourceError, setmanagepublicResourceError] = useState(false);
    const [managepublicResourceReadOnly, setmanagepublicResourceReadOnly] = useState(false);

    const [documentsSteP3, setdocumentsSteP3] = useState(null);
    const [documentsSteP3Error, setdocumentsSteP3Error] = useState(false);
    const [documentsSteP3ReadOnly, setdocumentsSteP3ReadOnly] = useState(false);




    //paso 4 variables

    const [documentsStep4Error, setdocumentsStep4Error] = useState(false);
    const [documentsStep4ReadOnly, setdocumentsStep4ReadOnly] = useState(false);

    const [shareholders, setShareholders] = useState([]);





    //paso 5 variables
    const [originFund, setoriginFund] = useState(null);
    const [originFundError, setoriginFundError] = useState(false);
    const [originFundReadOnly, setoriginFundReadOnly] = useState(false);

    const [haveExtraFund, sethaveExtraFund] = useState(false);
    const [haveExtraFundError, sethaveExtraFundError] = useState(false);
    const [haveExtraFundReadOnly, sethaveExtraFundReadOnly] = useState(false);

    const [extraFundDetail, setextraFundDetail] = useState(null);
    const [extraFundDetailError, setextraFundDetailError] = useState(false)
    const [extraFundDetailReadOnly, setextraFundDetailReadOnly] = useState(false);

    const [TermAndConditionDate, setTermAndConditionDate] = useState(false);
    const [TermAndConditionDateError, setTermAndConditionDateError] = useState(false);
    const [TermAndConditionDateReadOnly, setTermAndConditionDaterReadOnly] = useState(false);

    const [documentsStep5, setdocumentsStep5] = useState(null);
    const [documentsStep5Error, setdocumentsStep5Error] = useState(false);
    const [documentsStep5ReadOnly, setdocumentsStep5ReadOnly] = useState(false);





    //paso 6 variables
    const [documents1, setDocuments1] = useState(null);
    const [documents1Error, setDocuments1Error] = useState(false);
    const [documents1ReadOnly, setDocuments1ReadOnly] = useState(false);

    const [documents2, setDocuments2] = useState(null);
    const [documents2Error, setDocuments2Error] = useState(false);
    const [documents2ReadOnly, setDocuments2ReadOnly] = useState(false);


    const [documents3Error, setDocuments3Error] = useState(false);
    const [documents3ReadOnly, setDocuments3ReadOnly] = useState(null);

    const [documents4, setDocuments4] = useState(null);
    const [documents4Error, setDocuments4Error] = useState(false);
    const [documents4ReadOnly, setDocuments4ReadOnly] = useState(false);

    const [documents5, setDocuments5] = useState(null);
    const [documents5Error, setDocuments5Error] = useState(false);
    const [documents5ReadOnly, setDocuments5ReadOnly] = useState(false);

    const [documents6, setDocuments6] = useState(null);
    const [documents6Error, setDocuments6Error] = useState(false);
    const [documents6ReadOnly, setDocuments6ReadOnly] = useState(false);


    //paso 7 variables
    const [companyPending, setCompanyPending] = useState(null);
    const [totalCompany, setTotalCompany] = useState(false);
    const [detailLevelUser, setDetailLevelUser] = useState(false);





    const { getAuthenticatedHeaders, logout, } = useContext(AuthContext);

    const [ListCountry, setListCountry] = useState(null);
    const [ListCountryError, setListCountryError] = useState(null);
    const [ListCountryReadOnly, setListCountryReadOnly] = useState(null);

    const [listCategory, setListCategory] = useState(null);
    const [listCategoryError, setListCategoryError] = useState(null);
    const [listCategoryReadOnly, setListCategoryReadOnly] = useState(null);

    const [ListRange, setListRange] = useState(null);
    const [ListRangeError, setListRangeError] = useState(null);
    const [ListRangeReadOnly, setListRangeReadOnly] = useState(null);


    const [ModalActive, setModalActive] = useState(false)
    const [ModalActiveError, setModalActiveError] = useState(false)


    const [loading, setLoading] = useState(false)
    const [copied, setCopied] = useState(false);

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };





    useEffect(() => {
        if (paso === 1) {
            // Solo mostrar errores si hay valores en los campos
            if (enterpriseLegaName) {
                setEnterPriseLegaNameError(false);
            }
            if (enterpriseIdentification) {
                setEnterpriseIdentificationError(false);
            }
            if (creationDate) {
                setCreationDateError(false);
            }
            if (countryRegistered) {
                setCountryRegisteredError(false);
            }
            if (website) {
                setWebsiteError(false);
            }
            if (city) {
                setCityError(false);
            }
            if (countryState) {
                setCountryStateError(false);
            }
            if (phoneNumber) {
                setPhoneNumberError(false);
            }
            if (phoneNumberCode) {
                setPhoneNumberCodeError(false);
            }
            if (address) {
                setAddressError(false);
            }
            if (enterpriseDescription) {
                setEnterpriseDescriptionError(false);
            }
            if (ArhivoSociedad) {
                setArhivoSociedadError(false);
            }
            if (ArhivoTributario) {
                setArhivoTributarioError(false);
            }
            if (ArhivoMercantil) {
                setArhivoMercantilError(false);
            }
            if (ArhivoBrochure) {
                setArhivoBrochureError(false);
            }
        }
        setErrorMesagge('');
    }, [
        paso,
        enterpriseLegaName,
        enterpriseIdentification,
        creationDate,
        countryRegistered,
        website,
        city,
        countryState,
        phoneNumber,
        phoneNumberCode,
        address,
        enterpriseDescription,
        ArhivoSociedad,
        ArhivoTributario,
        ArhivoMercantil,
        ArhivoBrochure
    ]);

    useEffect(() => {
        if (paso === 2) {
            setCategoryIdError(false);
            setCategoryDescriptionError(false);
            setDocyearStatusError(false);
            setTotalAssetIdError(false);
            setTotalLiabilityIdError(false);
            setTotalEquityIdError(false);
            setTaxCountryError(false);
            setMonthlyIncomeIdError(false);
            setMonthlyExpensesIdError(false);
            setOtherIncomeDescriptionError(false);
            setotherIncomeIdError(false);
            sethaveInternationalTransactionCountryError(false);
            sethaveInternationalTransactionNumberError(false);
            sethaveInternationalTransactionEntidadError(false);
            sethaveInternationalTransactionRangoError(false);
            setByLicensedDocError(false);
            setErrorMesagge('')
        }

        if (paso === 3) {
            setnameLegalError(false);
            setlastNameLegalError(false);
            setdocumentNumberLegalError(false);

            setcountryLegalNameError(false);
            setdomicileStateError(false);
            setdomicileCityError(false);
            setdomicileAddressError(false);
            setdomicileDetailError(false);
            setphoneLegalAgentError(false);
            setemailLegalAgentError(false);
            setdocumentPPError(false);
            setpublicChargeError(false);
            setdetailChargeError(false);
            setErrorMesagge('')
        }

        if (paso === 5) {
            setoriginFundError(false);
            setdocumentsStep5Error(false);
            setextraFundDetailError(false);
            setTermAndConditionDateError(false)
            setErrorMesagge('')
            return
        }


        if (paso == 6) {
            setDocuments1Error(false);
            setDocuments2Error(false);
            setDocuments3Error(false);
            setDocuments4Error(false);
            setDocuments5Error(false);
            setDocuments6Error(false);
            setdocumentsStep4Error(false)
            setErrorMesagge('')
            return
        }
    }, [paso]);
    useEffect(() => {


        if (paso === 1) {

            if (enterpriseLegaName) {
                setEnterPriseLegaNameError(false);
            }
            if (enterpriseIdentification) {
                setEnterpriseIdentificationError(false);
            }
            if (creationDate) {
                setCreationDateError(false);
            }
            if (countryRegistered) {
                setCountryRegisteredError(false);
            }
            if (website) {
                setWebsiteError(false);
            }
            if (city) {
                setCityError(false);
            }
            if (countryState) {
                setCountryStateError(false);
            }
            if (phoneNumber) {
                setPhoneNumberError(false);
            }
            if (phoneNumberCode) {
                setPhoneNumberCodeError(false);
            }
            if (address) {
                setAddressError(false);
            }
            if (enterpriseDescription) {
                setEnterpriseDescriptionError(false);
            }
            if (ArhivoSociedad) {
                setArhivoSociedadError(false);
            }
            if (ArhivoTributario) {
                setArhivoTributarioError(false);
            }
            if (ArhivoMercantil) {
                setArhivoMercantilError(false);
            }
            if (ArhivoBrochure) {
                setArhivoBrochureError(false);
            }
            else {
                setErrorMesagge('')

            }

        }


        if (paso === 2) {
            if (categoryId) {
                setCategoryIdError(false);
            }
            if (categoryDescription) {
                setCategoryDescriptionError(false);
            }
            if (DocyearStatus) {
                setDocyearStatusError(false);
            }
            if (totalAssetId) {
                setTotalAssetIdError(false);
            }
            if (totalLiabilityId) {
                setTotalLiabilityIdError(false);
            }
            if (totalEquityId) {
                setTotalEquityIdError(false);
            }
            if (taxCountry) {
                setTaxCountryError(false);
            }
            if (monthlyIncomeId) {
                setMonthlyIncomeIdError(false);
            }
            if (monthlyExpensesId) {
                setMonthlyExpensesIdError(false);
            }
            if (haveOtherIncome === true) {
                if (otherIncomeDescription) {
                    setOtherIncomeDescriptionError(false);
                }
                if (otherIncomeId) {
                    setotherIncomeIdError(false);
                }
            }
            if (haveInternationalTransaction === true) {

                if (haveInternationalTransactionCountry) {
                    sethaveInternationalTransactionCountryError(false);
                }
                if (haveInternationalTransactionNumber) {
                    sethaveInternationalTransactionNumberError(false);
                }
                if (haveInternationalTransactionEntidad) {
                    sethaveInternationalTransactionEntidadError(false);
                }
                if (haveInternationalTransactionRango) {
                    sethaveInternationalTransactionRangoError(false);
                }
            }

            if (byLicensed === true) {
                console.log('estoy dentro');

                if (byLicensedDoc) {
                    setByLicensedDocError(false);
                }
            } else {
                setErrorMesagge('')

            }
        }

        if (paso === 3) {
            if (nameLegal) {
                setnameLegalError(false);
            }
            if (lastNameLegal) {
                setlastNameLegalError(false);
            }
            if (documentNumberLegal) {
                setdocumentNumberLegalError(false);
            }

            if (countryLegalName) {
                setcountryLegalNameError(false);
            }
            if (domicileState) {
                setdomicileStateError(false);
            }
            if (domicileCity) {
                setdomicileCityError(false);
            }
            if (domicileAddress) {
                setdomicileAddressError(false);
            }
            if (domicileDetail) {
                setdomicileDetailError(false);
            }
            if (phoneLegalAgent) {
                setphoneLegalAgentError(false);
            }
            if (emailLegalAgent) {
                setemailLegalAgentError(false);
            }
            if (documentPP) {
                setdocumentPPError(false);
            }
            if (isPep == true) {
                console.log('estoy dentro');
                if (publicCharge) {
                    setpublicChargeError(false);
                }
                if (detailCharge) {
                    setdetailChargeError(false);
                }
            } else {
                setErrorMesagge('')

            }
        }

        if (paso === 5) {
            if (originFund) {
                setoriginFundError(false);
                setErrorMesagge('')
            }

            if (documentsStep5) {
                setdocumentsStep5Error(false);
                setErrorMesagge('')
            }

            if (haveExtraFund == true) {
                if (extraFundDetail) {
                    setextraFundDetailError(false);
                    setErrorMesagge('')

                } else {
                    setErrorMesagge('')

                }

            }
            if (TermAndConditionDate) {
                setTermAndConditionDateError(false)
            }
        } else {
            setErrorMesagge('')

        }

        console.log("pasoajajsajsjajsajsjajsajsjaj", paso);

        if (paso == 6) {
            console.log("sjdjsjdsjdsjdjsjdsjdjsjdsjdjjsjdsjs");

            if (documents1) {
                setDocuments1Error(false);
            }
            if (documents2) {
                setDocuments2Error(false);
            }

            if (documents4) {
                setDocuments4Error(false);
            }
            if (documents5) {
                setDocuments5Error(false);
            }

            if (documents6) {
                setDocuments6Error(false);
            } else {
                setErrorMesagge('')
                return
            }
        }

    }, [
        TermAndConditionDate,
        enterpriseLegaName,
        enterpriseIdentification,
        creationDate,
        countryRegistered,
        website,
        city,
        countryState,
        phoneNumber,
        phoneNumberCode,
        address,
        enterpriseDescription,
        ArhivoSociedad,
        ArhivoTributario,
        ArhivoMercantil,
        ArhivoBrochure,
        categoryId,
        categoryDescription,
        DocyearStatus,
        totalAssetId,
        totalLiabilityId,
        totalEquityId,
        taxCountry,
        monthlyIncomeId,
        monthlyExpensesId,
        otherIncomeDescription,
        otherIncomeId,
        haveInternationalTransactionCountry,
        haveInternationalTransactionNumber,
        haveInternationalTransactionEntidad,
        haveInternationalTransactionRango,
        byLicensedDoc,
        nameLegal,
        lastNameLegal,
        documentNumberLegal,

        countryLegalName,
        domicileState,
        domicileCity,
        domicileAddress,
        domicileDetail,
        phoneLegalAgent,
        emailLegalAgent,
        documentPP,
        publicCharge,
        detailCharge,
        originFund,
        documentsStep5,
        extraFundDetail,
        TermAndConditionDate,
        documents1,
        documents2,

        documents4,
        documents5,
        documents6,


    ]);


    /* Validacion de los campos */
    const validateFieldsStep1 = () => {
        let isValid = true;


        if (isValid === false) {
            setErrorMesagge(`${t.validation.incomplete_data}`)
        }
        // Verificar valores de los inputs directamente en lugar de los errores
        if (!enterpriseLegaName) {
            setEnterPriseLegaNameError(true);
            isValid = false;

        } else {
            setEnterPriseLegaNameError(false);
        }

        if (!enterpriseIdentification) {
            setEnterpriseIdentificationError(true);
            isValid = false;
        } else {
            setEnterpriseIdentificationError(false);
        }

        if (!creationDate) {
            setCreationDateError(true);
            isValid = false;
        } else {
            setCreationDateError(false);
        }

        if (!countryRegistered) {
            setCountryRegisteredError(true);
            isValid = false;
        } else {
            setCountryRegisteredError(false);
        }

        if (!website) {
            setWebsiteError(true);
            isValid = false;
        } else {
            setWebsiteError(false);
        }

        if (!city) {
            setCityError(true);
            isValid = false;
        } else {
            setCityError(false);
        }

        if (!countryState) {
            setCountryStateError(true);
            isValid = false;
        } else {
            setCountryStateError(false);
        }

        if (!phoneNumber) {
            setPhoneNumberError(true);
            isValid = false;
        } else {
            setPhoneNumberError(false);
        }

        if (!phoneNumberCode) {
            setPhoneNumberCodeError(true);
            isValid = false;
        } else {
            setPhoneNumberCodeError(false);
        }

        if (!address) {
            setAddressError(true);
            isValid = false;
        } else {
            setAddressError(false);
        }

        if (!enterpriseDescription) {
            setEnterpriseDescriptionError(true);
            isValid = false;
        } else {
            setEnterpriseDescriptionError(false);
        }

        if (!ArhivoSociedad) {
            setArhivoSociedadError(true);
            isValid = false;
        } else {
            setArhivoSociedadError(false);
        }

        if (!ArhivoTributario) {
            setArhivoTributarioError(true);
            isValid = false;
        } else {
            setArhivoTributarioError(false);
        }

        if (!ArhivoMercantil) {
            setArhivoMercantilError(true);
            isValid = false;
        } else {
            setArhivoMercantilError(false);
        }

        if (!ArhivoBrochure) {
            setArhivoBrochureError(true);
            isValid = false;
        } else {
            setArhivoBrochureError(false);
        }

        return isValid;
    };

    console.log("city", city);

    /* Validacion de los campos */
    const validateFieldsStep2 = () => {
        let isValid = true;

        // Verificar valores de los inputs directamente en lugar de los errores

        if (!categoryId) {
            setCategoryIdError(true);
            isValid = false;

        } else {
            setCategoryIdError(false);
        }

        if (!categoryDescription) {
            setCategoryDescriptionError(true);
            isValid = false;
        } else {
            setCategoryDescriptionError(false);
        }

        if (!DocyearStatus) {
            setDocyearStatusError(true);
            isValid = false;
        } else {
            setDocyearStatusError(false);
        }

        if (!totalAssetId) {
            setTotalAssetIdError(true);
            isValid = false;
        } else {
            setTotalAssetIdError(false);
        }

        if (!totalLiabilityId) {
            setTotalLiabilityIdError(true);
            isValid = false;
        } else {
            setTotalLiabilityIdError(false);
        }
        if (!totalEquityId) {
            setTotalEquityIdError(true);
            isValid = false;
        } else {
            setTotalEquityIdError(false);
        }
        if (!taxCountry) {
            setTaxCountryError(true);
            isValid = false;
        } else {
            setTaxCountryError(false);
        }

        if (!monthlyIncomeId) {
            setMonthlyIncomeIdError(true);
            isValid = false;
        } else {
            setMonthlyIncomeIdError(false);
        }

        if (!monthlyExpensesId) {
            setMonthlyExpensesIdError(true);
            isValid = false;
        } else {
            setMonthlyExpensesIdError(false);
        }


        if (haveOtherIncome === true) {
            if (!otherIncomeDescription) {
                setOtherIncomeDescriptionError(true);
                isValid = false;
            } else {
                setOtherIncomeDescriptionError(false);
            }

            if (!otherIncomeId) {
                setotherIncomeIdError(true);
                isValid = false;
            } else {
                setotherIncomeIdError(false);
            }
        }


        if (haveInternationalTransaction === true) {


            if (!haveInternationalTransactionCountry) {
                sethaveInternationalTransactionCountryError(true);
                isValid = false;
            } else {
                sethaveInternationalTransactionCountryError(false);
            }
            if (!haveInternationalTransactionNumber) {
                sethaveInternationalTransactionNumberError(true);
                isValid = false;
            } else {
                sethaveInternationalTransactionNumberError(false);
            }
            if (!haveInternationalTransactionEntidad) {
                sethaveInternationalTransactionEntidadError(true);
                isValid = false;
            } else {
                sethaveInternationalTransactionEntidadError(false);

            }
            if (!haveInternationalTransactionRango) {
                sethaveInternationalTransactionRangoError(true);
                isValid = false;
            } else {
                sethaveInternationalTransactionRangoError(false);
            }
        }

        if (byLicensed === true) {


            if (!byLicensedDoc) {
                setByLicensedDocError(true);
                isValid = false;
            } else {
                setByLicensedDocError(false);
            }
        }

        return isValid;
    };


    /* Validacion de los campos */
    const validateFieldsStep3 = () => {
        let isValid = true;

        // Verificar valores de los inputs directamente en lugar de los errores
        if (!nameLegal) {
            setnameLegalError(true);
            isValid = false;

        } else {
            setnameLegalError(false);
        }

        if (!lastNameLegal) {
            setlastNameLegalError(true);
            isValid = false;
        } else {
            setlastNameLegalError(false);
        }

        if (!documentNumberLegal) {
            setdocumentNumberLegalError(true);
            isValid = false;
        } else {
            setdocumentNumberLegalError(false);
        }



        if (!countryLegalName) {
            setcountryLegalNameError(true);
            isValid = false;
        } else {
            setcountryLegalNameError(false);
        }

        if (!domicileState) {
            setdomicileStateError(true);
            isValid = false;
        } else {
            setdomicileStateError(false);
        }

        if (!domicileCity) {
            setdomicileCityError(true);
            isValid = false;
        } else {
            setdomicileCityError(false);
        }

        if (!domicileAddress) {
            setdomicileAddressError(true);
            isValid = false;
        } else {
            setdomicileAddressError(false);
        }

        if (!domicileDetail) {
            setdomicileDetailError(true);
            isValid = false;
        } else {
            setdomicileDetailError(false);
        }

        if (!phoneLegalAgent) {
            setphoneLegalAgentError(true);
            isValid = false;
        } else {
            setphoneLegalAgentError(false);
        }

        if (!emailLegalAgent) {
            setemailLegalAgentError(true);
            isValid = false;
        } else {
            setemailLegalAgentError(false);
        }

        if (!documentPP) {
            setdocumentPPError(true);
            isValid = false;
        } else {
            setdocumentPPError(false);
        }

        if (isPep == true) {


            if (!publicCharge) {
                setpublicChargeError(true);
                isValid = false;
            } else {
                setpublicChargeError(false);
            }
            if (!detailCharge) {
                setdetailChargeError(true);
                isValid = false;
            } else {
                setdetailChargeError(false);
            }
        }

        return isValid;
    };

    /* Validacion de los campos */
    const validateFieldsStep5 = () => {
        let isValid = true;

        // Verificar valores de los inputs directamente en lugar de los errores
        if (!originFund) {
            setoriginFundError(true);
            isValid = false;

        } else {
            setoriginFundError(false);
        }

        if (language !== "en" && !documentsStep5) {
            setdocumentsStep5Error(true);
            isValid = false;
        } else {
            setdocumentsStep5Error(false);
        }

        if (TermAndConditionDate === false) {
            setTermAndConditionDateError(true)
            isValid = false;
        } else {
            setTermAndConditionDateError(false);
        }

        if (haveExtraFund == true) {


            if (!extraFundDetail) {
                setextraFundDetailError(true);
                isValid = false;
            } else {
                setextraFundDetailError(false);
            }
        }

        return isValid;
    };



    /* Validacion de los campos */
    const validateFieldsStep6 = () => {
        let isValid = true;


        // Verificar valores de los inputs directamente en lugar de los errores
        if (!documents1) {
            setDocuments1Error(true);
            isValid = false;

        } else {
            setDocuments1Error(false);
        }

        if (!documents2) {
            setDocuments2Error(true);
            isValid = false;
        } else {
            setDocuments2Error(false);
        }




        if (!documents4) {
            setDocuments4Error(true)
            isValid = false;
        } else {
            setDocuments4Error(false);
        }
        if (!documents5) {
            setDocuments5Error(true)
            isValid = false;
        } else {
            setDocuments5Error(false);
        }


        return isValid;
    };


    const BackSteps2 = async () => {
        setLoadingBack(true)
        setAnimationBack(true)

        // Limpiar todos los estados de error inmediatamente
        const clearErrors = () => {
            setEnterPriseLegaNameError(false);
            setEnterpriseIdentificationError(false);
            setCreationDateError(false);
            setCountryRegisteredError(false);
            setWebsiteError(false);
            setCityError(false);
            setCountryStateError(false);
            setPhoneNumberError(false);
            setPhoneNumberCodeError(false);
            setAddressError(false);
            setEnterpriseDescriptionError(false);
            setArhivoSociedadError(false);
            setArhivoTributarioError(false);
            setArhivoMercantilError(false);
            setArhivoBrochureError(false);
            setErrorMesagge('');
        };

        // Limpiar campos
        const clearFields = () => {
            setEnterPriseLegaName(null);
            setEnterpriseIdentification(null);
            setCreationDate(null);
            setCountryRegistered(null);
            setWebsite(null);
            setCity(null);
            setCountryState(null);
            setPhoneNumber(null);
            setPhoneNumberCode(language == "es" ? '+57' : "+1");
            setAddress(null);
            setEnterpriseDescription(null);
            setArhivoSociedad(null);
            setArhivoTributario(null);
            setArhivoMercantil(null);
            setArhivoBrochure(null);
        };

        clearErrors();

        if (DataOnboarding != null) {
            await getInfoUser(1);
            setPaso(1);
            setLoadingBack(false);
            return;
        }

        const hasChanges = categoryId ||
            categoryDescription ||
            DocyearStatus ||
            totalAssetId ||
            totalLiabilityId ||
            totalEquityId ||
            taxCountry ||
            monthlyIncomeId ||
            monthlyExpensesId ||
            otherIncomeDescription ||
            otherIncomeId ||
            haveInternationalTransactionCountry ||
            haveInternationalTransactionNumber ||
            haveInternationalTransactionEntidad ||
            byLicensedDoc;

        if (hasChanges) {
            setTitle(`${t.modal_alert.title}`);
            setDescripcion(`${t.modal_alert.description}`);
            setLabelModalWhite(`${t.modal_alert.label_button_white}`);
            setModalActive(true);
            setLoadingBack(false);
            return;
        }

        clearFields();
        await getInfoUser(1);
        setPaso(1);
        setLoadingBack(false);
    }


    const BackSteps3 = async () => {
        setAnimationBack(true)
        setLoadingBack(true)

        if (DataOnboarding != null) {
            await getInfoUser(2)
            setPaso(2)
            setLoadingBack(false)

            return
        }
        if (documentTypeLegal ||

            documentNumberLegal ||
            nameLegal ||
            lastNameLegal ||
            countryLegalName ||
            domicileState ||
            domicileCity ||
            domicileAddress ||
            domicileDetail ||
            emailLegalAgent ||
            phoneLegalAgent ||
            phoneLegalAgentCode ||
            documentPP ||
            isPep ||
            publicCharge ||
            detailCharge ||
            managepublicResource ||
            documentsSteP3) {
            console.log("ioasas", documentTypeLegal ||

                documentNumberLegal ||
                nameLegal ||
                lastNameLegal ||
                countryLegalName ||
                domicileState ||
                domicileCity ||
                domicileAddress ||
                domicileDetail ||
                emailLegalAgent ||
                phoneLegalAgent ||
                phoneLegalAgentCode ||
                documentPP ||
                isPep ||
                publicCharge ||
                detailCharge ||
                managepublicResource ||
                documentsSteP3);

            /* setea varaibles en vacio del paso que se encuentra */
            setTitle(`${t.modal_alert_back.title}`)
            setDescripcion(`${t.modal_alert_back.description}`)
            setLabelModalWhite(`${t.modal_alert_back.label_button_next}`)
            setModalActive(true)
            setCategoryId(null)
            setCategoryDescription(null)
            setMonthlyIncomeId(null)
            setMonthlyExpensesId(null)
            setTotalAssetId(null)
            setTotalLiabilityId(null)
            setTotalEquityId(null)
            setTaxCountry(null)
            seThaveOtherIncome(false)
            setOtherIncomeDescription(null)
            setotherIncomeId(null)
            sethaveInternationalTransaction(false)
            setDocyearStatus(null)
            sethaveInternationalTransactionCountry(null)
            sethaveInternationalTransactionNumber(null)
            sethaveInternationalTransactionEntidad(null)
            sethaveInternationalTransactionRango(null)
            sethaveAml(false)
            setByLicensed(false)
            setByLicensedDoc(null)
            sethaveComplianceOfficer(false)
            sethaveVirtualAsset(false)
            setinternationalTransactions(null)
            setdocumentsStep2(null)

            return
        }
        if (validateFieldsStep3() === false) {

            setCategoryId(null)
            setCategoryDescription(null)
            setMonthlyIncomeId(null)
            setMonthlyExpensesId(null)
            setTotalAssetId(null)
            setTotalLiabilityId(null)
            setTotalEquityId(null)
            setTaxCountry(null)
            seThaveOtherIncome(false)
            setOtherIncomeDescription(null)
            setotherIncomeId(null)
            sethaveInternationalTransaction(false)
            setDocyearStatus(null)
            sethaveInternationalTransactionCountry(null)
            sethaveInternationalTransactionNumber(null)
            sethaveInternationalTransactionEntidad(null)
            sethaveInternationalTransactionRango(null)
            sethaveAml(false)
            setByLicensed(false)
            setByLicensedDoc(null)
            sethaveComplianceOfficer(false)
            sethaveVirtualAsset(false)
            setinternationalTransactions(null)
            setdocumentsStep2(null)
            await getInfoUser(2)
            setPaso(2)
            setModalActive(false)
        }

    }

    const BackSteps4 = async () => {
        setLoadingBack(true)
        setAnimationBack(true)
        if (DataOnboarding != null) {
            await getInfoUser(3)
            setPaso(3)
            setLoadingBack(false)

            return
        }
        setdocumentTypeLegal(null)

        setdocumentNumberLegal(null)
        setameLegal(null)
        setlastNameLegal(null)
        setcountryLegalName(null)
        setdomicileState(null)
        setdomicileCity(null)
        setdomicileAddress(null)
        setdomicileDetail(null)
        setemailLegalAgent(null)
        setphoneLegalAgent(null)
        setphoneLegalAgentCode(language == "es" ? '+57' : "+1")
        setdocumentPP(null)
        setisPep(false)
        setpublicCharge('')
        setdetailCharge(null)
        setmanagepublicResource(false)
        setdocumentsSteP3(null)
        setErrorMesagge('')
        setErrorMesagge('')

        setPaso(3)

    }
    const BackSteps5 = async () => {
        setAnimationBack(true)
        setLoadingBack(true)

        if (DataOnboarding != null) {
            await getInfoUser(4)
            setPaso(4)
            setLoadingBack(false)

            return
        }
        if (originFund ||
            haveExtraFund ||
            extraFundDetail ||
            TermAndConditionDate ||
            documentsStep5) {

            /* setea varaibles en vacio del paso que se encuentra */
            setTitle(`${t.modal_alert_back.title}`)
            setDescripcion(`${t.modal_alert_back.description}`)
            setLabelModalWhite(`${t.modal_alert_back.label_button_next}`)
            setModalActive(true)


            return
        } else {


            await getInfoUser(2)
            setPaso(4)
            setModalActive(false)
        }
    }
    const BackSteps7 = async () => {
        setLoadingBack(true)
        await getInfoUser(6)
        setAnimationBack(true)
        setPaso(6)
        setLoadingBack(false)
    }
    const BackSteps6 = async () => {
        setLoadingBack(true)
        setAnimationBack(true)
        if (DataOnboarding != null) {
            await getInfoUser(5)
            setPaso(5)
            setLoadingBack(false)

            return
        }
        if (documents1 ||
            documents2 ||
            documents4 ||
            documents5 ||
            documents6) {
            setTitle(`${t.modal_alert_back.title}`)
            setDescripcion(`${t.modal_alert_back.description}`)
            setLabelModalWhite(`${t.modal_alert_back.label_button_next}`)
            setModalActive(true)

            setoriginFund(null)
            sethaveExtraFund(false)
            setextraFundDetail(null)
            setTermAndConditionDate(false)
            setdocumentsStep5(null)


            return
        }

        if (validateFieldsStep2() === false) {

            console.log('es false');
            /* setear todos los errores a su estado original */
            setoriginFund(null)
            sethaveExtraFund(false)
            setextraFundDetail(null)
            setTermAndConditionDate(false)
            setdocumentsStep5(null)
            await getInfoUser(5)
            setPaso(5)
        }

    }


    /* funcines para devolvernos */
    const CloseModal = () => {
        setModalActive(false)
        setLoadingBack(false)
    }
    const ActiveModalBack = async () => {

        if (paso === 1) {
            setModalActive(false)
        }
        if (paso === 2) {
            setCategoryId(null)
            setCategoryDescription(null)
            setDocyearStatus(null)
            setTotalAssetId(null)
            setTotalLiabilityId(null)
            setTotalEquityId(null)
            setTaxCountry(null)
            setMonthlyIncomeId(null)
            setMonthlyExpensesId(null)
            setOtherIncomeDescription(null)
            setotherIncomeId(null)
            sethaveInternationalTransactionCountry(null)
            sethaveInternationalTransactionNumber(null)
            sethaveInternationalTransactionEntidad(null)
            sethaveInternationalTransactionRango(null)
            setByLicensedDoc(null)
            seThaveOtherIncome(false)
            sethaveInternationalTransaction(false)
            sethaveAml(false)
            setByLicensed(false)
            sethaveComplianceOfficer(false)
            sethaveVirtualAsset(false)
            setinternationalTransactions(null)
            setdocumentsStep2(null)
            await getInfoUser(1)
            setPaso(1)
            setModalActive(false)
        }
        if (paso === 3) {

            setdocumentTypeLegal(null)

            setdocumentNumberLegal(null)
            setameLegal(null)
            setlastNameLegal(null)
            setcountryLegalName(null)
            setdomicileState(null)
            setdomicileCity(null)
            setdomicileAddress(null)
            setdomicileDetail(null)
            setemailLegalAgent(null)
            setphoneLegalAgent(null)
            setphoneLegalAgentCode(language == "es" ? '+57' : "+1")
            setdocumentPP(null)
            setisPep(false)
            setpublicCharge('')
            setdetailCharge(null)
            setmanagepublicResource(false)
            setdocumentsSteP3(null)
            await getInfoUser(2)
            setPaso(2)
            setModalActive(false)
        }
        if (paso === 4) {



            setdocumentTypeLegal(null)

            setdocumentNumberLegal(null)
            setameLegal(null)
            setlastNameLegal(null)
            setcountryLegalName(null)
            setdomicileState(null)
            setdomicileCity(null)
            setdomicileAddress(null)
            setdomicileDetail(null)
            setemailLegalAgent(null)
            setphoneLegalAgent(null)
            setphoneLegalAgentCode(language == "es" ? '+57' : "+1")
            setdocumentPP(null)
            setisPep(false)
            setpublicCharge('')
            setdetailCharge(null)
            setmanagepublicResource(false)
            setdocumentsSteP3(null)
            setErrorMesagge('')
            await getInfoUser(3)
            setPaso(3)
            setModalActive(false)
        }
        if (paso === 5) {

            setoriginFund(null)
            sethaveExtraFund(false)
            setextraFundDetail(null)
            setTermAndConditionDate(false)
            setdocumentsStep5(null)
            await getInfoUser(4)
            setPaso(4)
            setModalActive(false)
        }
        if (paso === 6) {

            setDocuments1(null)
            setDocuments2(null)

            setDocuments4(null)
            setDocuments5(null)
            setDocuments6(null)

            await getInfoUser(5)
            setPaso(5)
            setModalActive(false)
        }
        setLoadingBack(false)

    }

    const BecomeDataFetch = async () => {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));

        await axios
            .post(`/verify_identity`, {
                id: userDetails.id

            })
            .then((response) => {



                setBecomeData(response.data.data)
            })
            .catch((error) => {

            });

    }

    const ListCountrys = async () => {

        await axios
            .post(`/api/country`, {})
            .then((response) => {

                setListCountry(response.data.data)
            })
            .catch((error) => {

            });
    }
    const ListCategory = async () => {

        await axios
            .post(`/api/category`, { headers: await getAuthenticatedHeaders(), country: language })
            .then((response) => {

                console.log(response.data.data);

                const formattedList = response.data.data.map(item => ({
                    code: item.id,  // Usa `id` como `code`
                    name: `${item.code} - ${item.name}` // Usa `range` como `name`
                }));
                setListCategory(formattedList)
            })
            .catch((error) => {

            });
    }
    const ListSate = async () => {

        await axios
            .post(`/api/states`, { headers: await getAuthenticatedHeaders(), country: language === "es" ? "CO" : "US" })
            .then((response) => {

                console.log(response.data.data);

                const formattedList = response.data.data.map(item => ({
                    code: item.id,  // Usa `id` como `code`
                    name: `${item.name}`,
                    cities: item.cities
                    // Usa `range` como `name`
                }));
                setListState(formattedList)
            })
            .catch((error) => {

            });
    }
    const ListSatecities = async () => {

        let departamento = ListaState.find(depto => depto.code === countryState)


        const final = departamento ? departamento.cities : 'ID no encontrado';
        console.log("final", final);
        const formatfinal = final.map(depto => ({
            code: depto.id,  // Renombrar 'id' a 'code'

            name: depto.name,

        }));


        setListCities(formatfinal)

    }
    const ListRangeSalary = async () => {

        await axios
            .post(`/api/salary_range`, { headers: await getAuthenticatedHeaders(), })
            .then((response) => {
                const formattedList = response.data.data.map(item => ({
                    code: item.id,  // Usa `id` como `code`
                    name: item.range // Usa `range` como `name`
                }));

                setListRange(formattedList);
            })
            .catch((error) => {

            });
    }
    async function copyToClipboard(url) {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // La notificación desaparece después de 2 segundos
        } catch (error) {
            console.error('Error al copiar al portapapeles', error);
        }
    }
    const BecomeDataStatysFetch = async () => {

        const userDetails = JSON.parse(localStorage.getItem('userDetails'));

        await axios
            .post(`/verify_identity/status`, {
                id: userDetails.id
            })
            .then((response) => {

                setLevelKYC(response.data.data.level);


            })
            .catch((error) => {

            });
        setLoadingKYC(false)
    }


    const BecomeDataStatysFetcha = async () => {
        setLoading(true)
        await axios
            .post(`/api/onboarding_check`, {
                headers: await getAuthenticatedHeaders(),

            })
            .then((response) => {
                console.log("response", response);

                if (
                    response.data.data.check_onboarding.documents_level === "COMPLETED" &&
                    response.data.data.check_onboarding.kyc === true &&
                    response.data.data.check_onboarding.kyc_shareholder === true

                ) {
                    return navigate("/documentacion-completa", { state: { DetailUser: DetailUser } });
                } else {
                    setTitle("Espera, ¡aún no terminas!")
                    setDescripcion("Debes completar todos los datos requeridos. Además, es necesario que el representante legal realice el proceso de KYC y que los beneficiarios finales también lo completen.")
                    setModalActiveError(true)
                }



            })

            .catch((error) => {
                setTitle("Espera, ¡aún no terminas!")
                setDescripcion("Debes completar todos los datos requeridos. Además, es necesario que el representante legal realice el proceso de KYC y que los beneficiarios finales también lo completen.")
                setModalActiveError(true)
            });
        setLoading(false)

    }
    const isObjectEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };
    const fechDataOnboardingStep1 = async (ArhivoSociedadURL, ArhivoTributarioURL, ArhivoMercantilURL, ArhivoBrochureURL) => {
        const storedData = localStorage.getItem("companyData");
        const parsedData = JSON.parse(storedData);

        const data = {
            "enterprise_name": parsedData.companyName || companyName,
            "interested_services": parsedData.ServiceColursFinal || ServiceColursFinal,
            "business_activities": parsedData.activityFinal || activityFinal,
            "enterprise_lega_name": enterpriseLegaName,
            "is_company_private": isCompanyPrivate == false ? 0 : isCompanyPrivate,
            "enterprise_identification": enterpriseIdentification,
            "creation_date": creationDate,
            "country_registered": countryRegistered,
            "state_id": countryState,
            "city_state_id": city,
            "address": address,
            "phone_country_code": phoneNumberCode,
            "phone_number": phoneNumber.replace(/\D/g, ""),
            "website": website,
            "enterprise_description": enterpriseDescription,
            "documents_1": [
                {
                    "code": "doc_company_incorporation",
                    "url": ArhivoSociedadURL
                },
                {
                    "code": "doc_tax_registry",
                    "url": ArhivoTributarioURL
                },
                {
                    "code": "doc_commercial_registry",
                    "url": ArhivoMercantilURL
                },
                {
                    "code": "doc_company_brochure",
                    "url": ArhivoBrochureURL
                }


            ],
            "step": "1"

        }

        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(2)

                    setCategoryId(null)
                    setCategoryDescription(null)
                    setMonthlyIncomeId(null)
                    setMonthlyExpensesId(null)
                    setTotalAssetId(null)
                    setTotalLiabilityId(null)
                    setTotalEquityId(null)
                    setTaxCountry(null)
                    seThaveOtherIncome(false)
                    setOtherIncomeDescription(null)
                    setotherIncomeId(null)
                    sethaveInternationalTransaction(false)
                    setDocyearStatus(null)
                    sethaveInternationalTransactionCountry(false)
                    sethaveInternationalTransactionNumber(null)
                    sethaveInternationalTransactionEntidad(null)
                    sethaveInternationalTransactionRango(null)
                    sethaveAml(false)
                    setByLicensed(false)
                    setByLicensedDoc(null)
                    sethaveComplianceOfficer(false)
                    sethaveVirtualAsset(false)
                    setinternationalTransactions(null)
                    setdocumentsStep2(null)
                }

            })
            .catch((error) => {

            });

    }


    const fechDataOnboardingStep2 = async (docyearStatus, ByLicensedDoc) => {
        setLoading(true)

        const data = {
            "category_id": categoryId,
            "category_description": categoryDescription,
            "monthly_income_id": monthlyIncomeId,
            "monthly_expenses_id": monthlyExpensesId,
            "total_asset_id": totalAssetId,
            "total_liability_id": totalLiabilityId,
            "total_equity_id": totalEquityId,
            "tax_country": taxCountry,
            "have_other_income": haveOtherIncome,

            "have_international_transaction": haveInternationalTransaction,

            "have_aml": haveAml,
            "have_compliance_officer": haveComplianceOfficer,
            "by_licensed": byLicensed,
            "have_virtual_asset": haveVirtualAsset,
            "documents_2": [{
                "code": "doc_financial_statement",
                "url": docyearStatus
            },

            ],
            "step": "2"
        }
        if (byLicensed) {
            {
                data.documents_2.push(
                    {
                        "code": "doc_license",
                        "url": ByLicensedDoc
                    }
                )
            }
        }

        console.log("haveOtherIncome", haveOtherIncome);

        if (haveOtherIncome) {
            data.other_income_id = otherIncomeId
            data.other_income_description = otherIncomeDescription;
        }
        if (haveInternationalTransaction) {
            data.international_transactions = [
                {
                    "country_transaction": haveInternationalTransactionCountry,
                    "international_number_product": haveInternationalTransactionNumber,
                    "entity": haveInternationalTransactionEntidad,
                    "transaction_amount": haveInternationalTransactionRango
                }
            ];
        }




        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(3)
                    BecomeDataFetch()


                    setdocumentTypeLegal(null)

                    setdocumentNumberLegal(null)
                    setameLegal(null)
                    setlastNameLegal(null)
                    setcountryLegalName(null)
                    setdomicileState(null)
                    setdomicileCity(null)
                    setdomicileAddress(null)
                    setdomicileDetail(null)
                    setemailLegalAgent(null)
                    setphoneLegalAgent(null)
                    setphoneLegalAgentCode(language == "es" ? '+57' : "+1")
                    setdocumentPP(null)
                    setisPep(false)
                    setpublicCharge('')
                    setdetailCharge(null)
                    setmanagepublicResource(false)
                    setdocumentsSteP3(null)

                }
            })
            .catch((error) => {

            });
        setLoading(false)

    }
    const fechDataOnboardingStep3 = async (copy) => {
        setLoading(true)
        console.log("validateEmail(emailLegalAgent)", validateEmail(emailLegalAgent));

        if (!validateEmail(emailLegalAgent)) {
            setemailLegalAgentError(true)

            return

        }
        const data = {
            "document_type_legal": "4",
            "document_number_legal": documentNumberLegal,
            "name_legal": nameLegal,
            "last_name_legal": lastNameLegal,
            "country_legal_name": countryLegalName,
            "domicile_state": domicileState,
            "domicile_city": domicileCity,
            "domicile_address": domicileAddress,
            "domicile_detail": domicileDetail,
            "email_legal_agent": emailLegalAgent,
            "phone_country_code_legal_agent": phoneLegalAgentCode,
            "phone_legal_agent": phoneLegalAgent.replace(/\D/g, ""),
            "is_pep": isPep,
            "manage_public_resource": managepublicResource,
            "documents_3": [
                {
                    "code": "doc_passport_representant",
                    "url": copy
                }
            ],
            "step": "3"
        }
        if (isPep) {
            data.public_charge = publicCharge
            data.detail_charge = detailCharge;
        }


        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(4)


                }






            })
            .catch((error) => {
            });
        setLoading(false)
    }
    function filterByNonEmptyKey(array, key) {
        return array.filter(item => item[key] !== "");
    }
    const processDocuments = async (array) => {
        // Usa Promise.all para enviar archivos en paralelo por cada objeto
        return Promise.all(
            array.map(async (item) => {
                const updatedItem = { ...item }; // Copiamos el objeto para no mutarlo directamente

                if (updatedItem.doc_government_issued_id) {
                    try {
                        const url = await uploadFile(
                            "doc_government_issued_id",
                            updatedItem.doc_government_issued_id
                        );
                        updatedItem.doc_government_issued_id = url; // Sustituye el archivo por la URL
                    } catch (error) {
                        console.error("Error uploading doc_government_issued_id:", error);
                    }
                }

                if (updatedItem.doc_shareholder_certificate) {
                    try {
                        const url = await uploadFile(
                            "doc_shareholder_certificate",
                            updatedItem.doc_shareholder_certificate
                        );
                        updatedItem.doc_shareholder_certificate = url; // Sustituye el archivo por la URL
                    } catch (error) {
                        console.error(
                            "Error uploading doc_shareholder_certificate:",
                            error
                        );
                    }
                }

                return updatedItem;
            })
        );
    };
    const formatData = (data) => {
        // Inicializamos el array de documentos
        const shareholderDocuments = [];

        // Verificamos y añadimos el documento de identificación gubernamental
        if (data.doc_government_issued_id && typeof data.doc_government_issued_id === "string") {
            shareholderDocuments.push({
                code: "doc_government_issued_id",
                url: data.doc_government_issued_id,
            });
        }

        // Verificamos y añadimos el certificado de accionista
        if (data.doc_shareholder_certificate && typeof data.doc_shareholder_certificate === "string") {
            shareholderDocuments.push({
                code: "doc_shareholder_certificate",
                url: data.doc_shareholder_certificate,
            });
        }

        // Retornamos el objeto formateado
        return {
            type_person: data.type_person || null,
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            enterprise_legal_name: data.enterprise_legal_name || "",
            enterprise_identification: data.enterprise_identification || "",
            entity: "string", // Valor predeterminado
            participation_percentage: data.participation_percentage || "",
            country: data.country || "AL",
            is_pep: data.is_pep || false,
            level: 0, // Nivel predeterminado
            shareholder_documents: shareholderDocuments,
        };
    };

    const processMultipleObjects = (dataArray) => {
        return dataArray.map((data) => formatData(data));
    };
    const fechDataOnboardingSaveShareholders = async () => {

        try {
            const result = filterByNonEmptyKey(shareholders, "participation_percentage");
            console.log("filterByNonEmptyKey", result);
            const resultfinal = await processDocuments(result)
            console.log("resultfinal", resultfinal);

            /*             const formateofinal = formatData(resultfinal)
             */

            const formattedArray = processMultipleObjects(resultfinal);

            console.log("final datos:>:::", formattedArray);

            /*  const document1 = await uploadFile("doc_government_issued_id",)
             const document2 = await uploadFile("doc_shareholder_certificate",) */

            const data = {
                shareholders: formattedArray,
                step: "4",
            };



            const headers = await getAuthenticatedHeaders(); // Obtén los headers autenticados
            const response = await axios.post(`/api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },);
            if (response?.data?.status === 200) {

                fechDataOnboardingShareholdersStatus();
            } else {
                console.error(
                    "La solicitud fue exitosa pero el estado no es 200:",
                    response?.data
                );
            }
        } catch (error) {
            console.error("Error en fechDataOnboardingSaveShareholders:", error);

            // Puedes manejar errores específicos según el tipo
            if (error.response) {
                console.error("Respuesta del servidor:", error.response.data);
            } else if (error.request) {
                console.error("No se recibió respuesta del servidor:", error.request);
            } else {
                console.error("Error al configurar la solicitud:", error.message);
            }
        }
    };
    const fechDataOnboardingShareholdersStatus = async () => {
        await axios
            .post(`api/enterprise_form_data`, { headers: await getAuthenticatedHeaders(), step: "4" },)
            .then((response) => {
                if (response.data.status == 200) {
                    setDataCompany(response.data.data.shareholders)
                    const levelFiveCount = response.data.data.shareholders.filter(shareholder => shareholder.level === 5).length;

                    const totalObjects = response.data.data.shareholders.length;
                    console.log("response.data.data", response.data.data);

                    const ids = response.data?.data?.shareholders?.map((item) => item.id);
                    const promises = ids.map((id) => fechDataStatus(id)); // Crear promesas




                    setCompanyPending(totalObjects)
                    setTotalCompany(levelFiveCount)
                }
            })
            .catch((error) => {

            });
        setLoadingBenefactores(false)

        setLoading(false)
    }
    function validarCampos(array, camposIgnorados = []) {
        for (const objeto of array) {
            for (const [clave, valor] of Object.entries(objeto)) {
                // Si la clave no está en camposIgnorados y el valor es null o vacío
                if (!camposIgnorados.includes(clave) && (valor === null || valor === "")) {
                    return true; // Hay un campo requerido vacío
                }
            }
        }
        return false; // Todo está válido
    }
    function validarCamposDocumentosStep6(array, camposIgnorados = []) {
        // Recorre cada objeto en el array
        for (const objeto of array) {
            console.log("Revisando objeto:", objeto);

            // Verifica si el objeto tiene la clave 'documents_step_6' que es un array
            if (objeto.documents_step_6 && Array.isArray(objeto.documents_step_6)) {
                // Si es un array, recorre cada elemento dentro de 'documents_step_6'
                for (const doc of objeto.documents_step_6) {
                    console.log("Revisando documento:", doc);

                    // Recorre las claves y valores de cada objeto dentro de 'documents_step_6'
                    for (const [clave, valor] of Object.entries(doc)) {
                        console.log(`Revisando campo: ${clave}, valor: ${valor}`);

                        // Verifica si la clave es "url" y no está en camposIgnorados, y si el valor es null o vacío
                        if (clave === "url" && !camposIgnorados.includes(clave) && (valor === null || valor === "")) {
                            console.log("Encontrada url vacía o null.");
                            return true; // Retorna true si encuentra una URL vacía o null
                        }
                    }
                }
            }
        }
        console.log("Todas las URLs son válidas.");
        return false; // Si todas las URLs son válidas
    }


    const getInfoUser = async (x) => {
        if (x == 7) {
            return
        }
        setLoadingLayouts(true)
        await axios
            .post(`api/enterprise_form_data`, { headers: await getAuthenticatedHeaders(), step: x ? x : paso },)
            .then(async (response) => {

                if (response.data.status == 200) {
                    let validation
                    if (paso != 6) {
                        validation = await validarCampos([response.data.data], ["extra_fund_detail", "other_income", "other_income_description", "international_transactions", "public_charge", "detail_charge", "extra_fund_detail"])
                    } else {
                        validation = await validarCamposDocumentosStep6([response.data.data],)
                        console.log("validation", validation);


                    }
                    console.log("validation", validation);

                    if (validation) {
                        setDataOnboarding(null)
                    } else {
                        setDataOnboarding(response.data.data)
                    }



                }


                /* aqui va el manejo de los errores back */


            })
            .catch((error) => {

            });
        setLoadingLayouts(false)
        setLoadingBenefactores(false)
        setLoadingBack(false)
        setLoading(false)
    }
    const getStepInfo = async () => {


        await axios
            .post(`/api/user`, { headers: await getAuthenticatedHeaders(), },)
            .then(async (response) => {

                if (response.data.status == 200) {
                    console.log(response?.data?.data?.onboarding?.step)
                    setProgressStep(response?.data?.data?.onboarding?.step)

                }


                /* aqui va el manejo de los errores back */


            })
            .catch((error) => {

            });

    }

    const fechDataOnboardingStep4 = async () => {
        setLoading(true)
        const data = {
            "shareholders": shareholders,

            "step": "4"
        }

        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(5)
                    setoriginFund(null)
                    sethaveExtraFund(false)
                    setextraFundDetail(null)
                    setTermAndConditionDate(null)
                    setdocumentsStep5(null)

                }






            })
            .catch((error) => {

            });
        setLoading(false)
    }
    const fechDataOnboardingStep5 = async (archivo) => {
        setLoading(true)
        let data = {}
        if (language === "en") {
            data = {
                "origin_fund": originFund,
                "have_extra_fund": haveExtraFund,

                "term_and_condition_date": moment().format('YYYY-MM-DD HH:mm:ss'),

                "step": "5"
            }
        } else {
            data = {
                "origin_fund": originFund,
                "have_extra_fund": haveExtraFund,

                "term_and_condition_date": moment().format('YYYY-MM-DD HH:mm:ss'),
                "documents_5": [{
                    "code": "doc_fund_source",
                    "url": archivo
                },

                ],
                "step": "5"
            }
        }

        if (haveExtraFund) {
            data.extra_fund_detail = extraFundDetail
        }

        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(6)

                    setDocuments1(null);
                    setDocuments2(null);
                    setDocuments4(null);
                    setDocuments5(null);
                    setDocuments6(null);
                    setdocumentsStep4Error(null)

                }






            })
            .catch((error) => {

            });
        setLoading(false)
    }
    console.log("countryState", countryState);

    const fechEditData = async (info) => {

        setLoading(true)
        const data = {
            ...info,
            "step": paso
        }
        console.log("data", data);


        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    getInfoUser(paso + 1)
                    setPaso(paso + 1)
                }






            })
            .catch((error) => {

            });
        setLoading(false)
    }
    const fechDataOnboardingStep6 = async (doc1, doc2, doc4, doc5,) => {

        setLoading(true)
        const data = {

            "documents_6": [{
                "code": "doc_good_conduite",
                "url": doc1
            },
            {
                "code": "doc_company_domicile",
                "url": doc2
            },

            {
                "code": "doc_accountant_background",
                "url": doc4
            },
            {
                "code": "doc_accountant_card",
                "url": doc5
            },


            ],
            "step": "6"
        }

        await axios
            .post(`api/enterprise_form`, { headers: await getAuthenticatedHeaders(), data },)
            .then((response) => {
                if (response.data.status == 200) {
                    setPaso(7)
                }






            })
            .catch((error) => {

            });
        setLoading(false)
    }

    const uploadFile = async (name, archivo,) => {

        console.log("uploadFile", name);

        setLoading(true)
        let file = archivo;

        const originalFileName = file?.name; // Por ejemplo: "Documento sin título.pdf"

        const formato = originalFileName.split('.').pop(); // Obtiene "pdf"
        console.log(formato);


        let newFileName = `${name}/${moment().valueOf()}.${formato}`;

        const headers = {
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY_DEV,
        };







        // Generar la firma
        const sign = getHashKey('documents'); // asegúrate de que 'documents' sea el valor correcto
        let formData = new FormData();
        formData.append("file", file);
        formData.append("sign", sign);
        formData.append("file_type", "documents");
        formData.append("file_name", newFileName);


        const header = await getAuthenticatedHeaders()
        const extendedHeaders = {
            ...header, // Los encabezados que ya tienes
            'Content-Type': 'multipart/form-data', // Otro ejemplo de encabezado adicional
        };



        const jsonString = JSON.stringify(extendedHeaders);
        formData.append("header", jsonString);


        try {
            const response = await axios.post(`/upload-image`, formData,)
            console.log("response", response.data.data.result);

            if (response.data.data.result === "OK") {
                console.log("response", response);


                return (response.data.data.url)

            }
        } catch (error) {
            setLoading(false)
            if (error.status === 413) {
                return "Archivo demasiado grande"
            } else {
                return "no se pudo subir el archivo"
            }
        }
        setLoading(false)
    };
    function getDifferences(obj1, obj2) {
        const differences = {};

        for (const key in obj2) {
            if (Array.isArray(obj2[key]) && Array.isArray(obj1[key])) {
                // Comparar arrays
                if (obj2[key].length !== obj1[key].length || !obj2[key].every((val, index) => val === obj1[key][index])) {
                    differences[key] = obj2[key];
                }
            } else if (obj2[key] !== obj1[key]) {
                // Comparar otros tipos de valores
                differences[key] = obj2[key];
            }
        }

        return differences;
    }
    const ConinuarStep1 = async () => {


        if (DataOnboarding !== null) {

            setLoading(true)
            const obj = {

                "enterprise_lega_name": enterpriseLegaName,
                "is_company_private": isCompanyPrivate == false ? 0 : isCompanyPrivate,
                "enterprise_identification": enterpriseIdentification,
                "creation_date": creationDate,
                "country_registered": countryRegistered,
                "country_state": countryState,
                "city": city,
                "address": address,
                "phone_country_code": phoneNumberCode,
                "phone_number": phoneNumber.replace(/\D/g, ""),
                "website": website,
                "enterprise_description": enterpriseDescription,
            }
            const valor = await getDifferences(DataOnboarding, obj)





            if (isObjectEmpty(valor) && typeof ArhivoSociedad === "string" && typeof ArhivoTributario === "string" && typeof ArhivoMercantil === "string" && typeof ArhivoBrochure === "string") {
                await getInfoUser(2)
                return setPaso(2)

            } else {
                let ArhivoSociedadURL = null
                let ArhivoTributarioURL = null
                let ArhivoMercantilURL = null
                let ArhivoBrochureURL = null


                if (typeof ArhivoSociedad !== "string") {


                    ArhivoSociedadURL = await uploadFile("arhivo_sociedad", ArhivoSociedad);
                    if (ArhivoSociedadURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setArhivoSociedadError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ArhivoSociedadURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion(`${t.modal_alert_pdf_error.description}`);
                        setArhivoSociedadError(true)
                        setModalActiveError(true)
                        return
                    }


                } else if (typeof ArhivoTributario !== "string") {
                    ArhivoTributarioURL = await uploadFile("arhivo_registro_tributario", ArhivoTributario);
                    if (ArhivoTributarioURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setArhivoTributarioError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ArhivoTributarioURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setArhivoTributarioError(true)
                        setModalActiveError(true)
                        return
                    }


                } else if (typeof ArhivoMercantil !== "string") {
                    ArhivoMercantilURL = await uploadFile("arhivo_registro_mercantil", ArhivoMercantil);

                    if (ArhivoMercantilURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setArhivoMercantilError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ArhivoMercantilURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setArhivoMercantilError(true)
                        setModalActiveError(true)
                        return
                    }


                } else if (typeof ArhivoTributario !== "string") {
                    ArhivoBrochureURL = await uploadFile("arhivo_brochure", ArhivoBrochure);
                    if (ArhivoBrochureURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setArhivoBrochureError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ArhivoBrochureURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setArhivoBrochureError(true)
                        setModalActiveError(true)
                        return
                    }
                }
                if (typeof ArhivoSociedad !== "string" || typeof ArhivoTributario !== "string" || typeof ArhivoMercantil !== "string" || typeof ArhivoBrochure !== "string") {
                    valor.documents_1 = [];

                }


                if (ArhivoSociedadURL != null) {

                    await valor.documents_1.push({
                        "code": "doc_company_incorporation",
                        "url": ArhivoSociedadURL
                    },);
                } else if (ArhivoMercantilURL != null) {

                    await valor.documents_1.push({
                        "code": "doc_commercial_registry",
                        "url": ArhivoMercantilURL
                    },);
                }
                else if (ArhivoBrochureURL != null) {
                    await valor.documents_1.push({
                        "code": "doc_company_brochure",
                        "url": ArhivoBrochureURL
                    },);
                }
                else if (ArhivoSociedadURL != null) {
                    await valor.documents_1.push({
                        "code": "doc_company_incorporation",
                        "url": ArhivoSociedadURL
                    },);
                }
                console.log("valor", valor);

                fechEditData(valor)
                return
            }


        }





        setAnimationBack(false)

        setLoading(true); // Comenzar mostrando el estado de carga
        if (!validateFieldsStep1()) {
            setError(true);
            setErrorMesagge(`${t.validation.incomplete_data}`);
            setLoading(false); // Detener el estado de carga si los campos no son válidos
            return;
        }

        try {
            const ArhivoSociedadURL = await uploadFile("arhivo_sociedad", ArhivoSociedad);
            if (ArhivoSociedadURL === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setArhivoSociedadError(true)
                setModalActiveError(true)
                return
            }
            else if (ArhivoSociedadURL === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setArhivoSociedadError(true)
                setModalActiveError(true)
                return
            }

            const ArhivoTributarioURL = await uploadFile("arhivo_registro_tributario", ArhivoTributario);
            if (ArhivoTributarioURL === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setArhivoTributarioError(true)
                setModalActiveError(true)
                return
            }
            else if (ArhivoTributarioURL === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setArhivoTributarioError(true)
                setModalActiveError(true)
                return
            }
            const ArhivoMercantilURL = await uploadFile("arhivo_registro_mercantil", ArhivoMercantil);
            if (ArhivoMercantilURL === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setArhivoMercantilError(true)
                setModalActiveError(true)
                return
            }
            else if (ArhivoMercantilURL === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setArhivoMercantilError(true)
                setModalActiveError(true)
                return
            }
            const ArhivoBrochureURL = await uploadFile("arhivo_brochure", ArhivoBrochure);
            if (ArhivoBrochureURL === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setArhivoBrochureError(true)
                setModalActiveError(true)
                return
            }
            else if (ArhivoBrochureURL === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setArhivoBrochureError(true)
                setModalActiveError(true)
                return
            }
            await fechDataOnboardingStep1(ArhivoSociedadURL, ArhivoTributarioURL, ArhivoMercantilURL, ArhivoBrochureURL);
        } catch (error) {
            console.error("Error al subir archivos o enviar datos:", error);
            setError(true);
            setErrorMesagge('Ocurrió un error al intentar continuar. Por favor, inténtelo de nuevo.');
        } finally {
            setLoading(false); // Detener el estado de carga al finalizar (éxito o error)
        }
    };
    const renameAttributes = (obj) => {
        // Mapeo de atributos a sus nuevos nombres
        const attributeMapping = {
            category: "category_id",
            monthly_income: "monthly_income_id",
            monthly_expenses: "monthly_expenses_id",
            total_asset: "total_asset_id",
            total_liability: "total_liability_id",
            total_equity: "total_equity_id",
            other_income: "other_income_id"
        };

        // Crear un nuevo objeto con los nombres de atributo cambiados si es necesario
        const updatedObj = Object.keys(obj).reduce((acc, key) => {
            // Si el atributo está en el mapeo, cambiar el nombre
            const newKey = attributeMapping[key] || key;
            acc[newKey] = obj[key];
            return acc;
        }, {});

        return updatedObj;
    };
    const ConinuarStep2 = async () => {
        setAnimationBack(false)

        if (DataOnboarding !== null) {


            setLoading(true)
            const obj = {

                "category": categoryId,
                "monthly_income": monthlyIncomeId,
                "monthly_expenses": monthlyExpensesId,
                "total_asset": totalAssetId,
                "total_liability": totalLiabilityId,
                "total_equity": totalEquityId,

                "category_description": categoryDescription,
                "tax_country": taxCountry,
                "have_other_income": haveOtherIncome,
                "other_income_description": otherIncomeDescription,
                "other_income": otherIncomeId,
                "have_international_transaction": haveInternationalTransaction,
                "have_aml": haveAml,
                "have_compliance_officer": haveComplianceOfficer,
                "by_licensed": byLicensed,
                "have_virtual_asset": haveVirtualAsset,
                "international_transactions": haveInternationalTransaction === true ? [
                    {
                        "country_transaction": haveInternationalTransactionCountry,
                        "international_number_product": haveInternationalTransactionNumber,
                        "entity": haveInternationalTransactionEntidad,
                        "transaction_amount": haveInternationalTransactionRango
                    }
                ] : [],

            }

            const valor = await getDifferences(DataOnboarding, obj)
            const result = renameAttributes(valor);





            console.log("isObjectEmpty(result)", typeof byLicensedDoc);

            if (isObjectEmpty(result) && typeof DocyearStatus === "string" && typeof byLicensedDoc === "string") {

                await getInfoUser(3)
                return setPaso(3)

            } else {
                console.log("haveInternationalTransaction---------------",);
                let docyearStatusURL = null
                let ByLicensedDocURL = null



                if (typeof DocyearStatus !== "string") {
                    docyearStatusURL = await uploadFile("Estados_financieros_año", DocyearStatus)
                    if (docyearStatusURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setDocyearStatusError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (docyearStatusURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setDocyearStatusError(true)
                        setModalActiveError(true)
                        return
                    }

                } else if (typeof byLicensedDoc !== "string") {
                    ByLicensedDocURL = await uploadFile("licencia", byLicensedDoc)
                    if (ByLicensedDocURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setByLicensedDocError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ByLicensedDocURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setByLicensedDocError(true)
                        setModalActiveError(true)
                        return
                    }

                }
                if (typeof DocyearStatus !== "string" || typeof byLicensedDoc !== "string") {
                    result.documents_2 = [];

                }
                if (docyearStatusURL != null) {

                    await result.documents_2.push({
                        "code": "doc_financial_statement",
                        "url": docyearStatusURL
                    },);
                } else if (ByLicensedDocURL != null) {

                    await result.documents_2.push({
                        "code": "doc_license",
                        "url": ByLicensedDocURL
                    },);
                }

                fechEditData(result)
                return
            }


        }
        if (!validateFieldsStep2()) {
            setError(true);
            setErrorMesagge(`${t.validation.incomplete_data}`);
            setLoading(false); // Detener el estado de carga si los campos no son válidos
            return;
        }


        const docyearStatus = await uploadFile("Estados_financieros_año", DocyearStatus)
        if (docyearStatus === "Archivo demasiado grande") {
            setTitle(`${t.modal_alert_pdf_large.title}`);
            setDescripcion(`${t.modal_alert_pdf_large.description}`);
            setDocyearStatusError(true)
            setModalActiveError(true)
            return
        }
        else if (docyearStatus === "no se pudo subir el archivo") {
            setTitle(`${t.modal_alert_pdf_error.title}`);
            setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
            setDocyearStatusError(true)
            setModalActiveError(true)
            return
        }
        let ByLicensedDoc = null
        if (byLicensed) {
            ByLicensedDoc = await uploadFile("licencia", byLicensedDoc)
            if (ByLicensedDoc === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setByLicensedDocError(true)
                setModalActiveError(true)
                return
            }
            else if (ByLicensedDoc === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setByLicensedDocError(true)
                setModalActiveError(true)
                return
            }

        }

        fechDataOnboardingStep2(docyearStatus, ByLicensedDoc)

    }


    const ConinuarStep3 = async () => {
        setAnimationBack(false)

        setLoading(true); // Comenzar mostrando el estado de carga
        if (DataOnboarding !== null) {

            setLoading(true)
            const obj = {
                "document_type_legal": 4,
                "document_number_legal": documentNumberLegal,
                "name_legal": nameLegal,
                "last_name_legal": lastNameLegal,
                "country_legal_name": countryLegalName,
                "domicile_state": domicileState,
                "domicile_city": domicileCity,
                "domicile_address": domicileAddress,
                "domicile_detail": domicileDetail,
                "email_legal_agent": emailLegalAgent,
                "phone_country_code_legal_agent": phoneLegalAgentCode,
                "phone_legal_agent": phoneLegalAgent.replace(/\D/g, ""),
                "is_pep": isPep,
                "manage_public_resource": managepublicResource,
                "public_charge": publicCharge,
                "detail_charge": detailCharge

            }
            const valor = await getDifferences(DataOnboarding, obj)


            if (isObjectEmpty(valor) && typeof documentPP === "string") {
                await getInfoUser(4)
                setLoading(false)
                return setPaso(4)

            } else {
                let ppdocumentLegalURL = null
                let ppURL = null



                if (typeof documentPP !== "string") {
                    ppURL = await uploadFile("pasaporte_representante_legal", documentPP);
                    if (ppURL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setdocumentPPError(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (ppURL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setdocumentPPError(true)
                        setModalActiveError(true)
                        return
                    }

                }
                if (typeof documentPP !== "string") {
                    valor.documents_3 = [];

                }
                if (ppdocumentLegalURL != null) {

                    await valor.documents_3.push({
                        "code": "passport_image",
                        "url": ppdocumentLegalURL
                    },);
                } else if (ppURL != null) {

                    await valor.documents_3.push({
                        "code": "doc_passport_representant",
                        "url": ppURL
                    },);
                }

                fechEditData(valor)
                return
            }


        }

        if (!validateFieldsStep3()) {
            setError(true);
            setErrorMesagge(`${t.validation.incomplete_data}`);
            setLoading(false); // Detener el estado de carga si los campos no son válidos
            return;
        }

        try {

            const pp = await uploadFile("pasaporte_representante_legal", documentPP);
            if (pp === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setdocumentPPError(true)
                setModalActiveError(true)
                return
            }
            else if (pp === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setdocumentPPError(true)
                setModalActiveError(true)
                return
            }
            await fechDataOnboardingStep3(pp);
        } catch (error) {
            // Manejo de errores en caso de que alguna petición falle
            setError(true);
            setErrorMesagge('Ocurrió un error durante el proceso');
            console.error(error);
        } finally {
            setLoading(false); // Finalizar el estado de carga
        }
    };

    const alertConitnue3 = () => {

        setTitle(`${t.modal_alert_kyc.title}`);
        setDescripcion(`${t.modal_alert_kyc.description}`);
        setModalActiveError(true)

    }

    const alertConitnue4 = () => {

        setTitle(t.modal_alert_shelholder.title);
        setDescripcion(t.modal_alert_shelholder.description);

        setModalActiveError(true)

    }
    const ConinuarStep4 = async () => {

        if (DataCompany.length === 0) {
            setTitle(`${t.modal_alert_shelholder.title}`);
            setDescripcion(`${t.modal_alert_shelholder.description}`);
            setErrorCompany(true)
            setModalActiveError(true)
            return
        }
        setAnimationBack(false)
        const validation = validateArray(DataCompany)
        console.log("validation", validation);

        if (!validation) {
            setTitle("Completa todos los campos requeridos")
            setDescripcion("Para continuar con el proceso, asegúrate de llenar toda la información solicitada en cada campo. Esto nos permitirá procesar correctamente tus datos y garantizar una experiencia fluida.")
            setErrorCompany(true)

            setModalActiveError(true)
            return
        }

        setLoading(true); // Comenzar mostrando el estado de carga
        try {
            await getInfoUser(5)
            setPaso(5); // Cambiar al paso 5
        } catch (error) {
            console.error('Error al avanzar al paso 5:', error);
            setError(true);
            setErrorMesagge('Ocurrió un error al avanzar al siguiente paso');
        } finally {
            setLoading(false); // Finalizar el estado de carga
        }
    };

    const ConinuarStep5 = async () => {
        setAnimationBack(false)

        setLoading(true); // Comenzar mostrando el estado de carga
        if (DataOnboarding !== null) {

            if (language === "en") {
                delete DataOnboarding.documents_step_5;
                delete DataOnboarding.extraFundDetail;

            }



            setLoading(true)
            const obj = {
                "origin_fund": originFund,
                "have_extra_fund": haveExtraFund,
                "extra_fund_detail": extraFundDetail
            }
            console.log("DataOnboarding", DataOnboarding);

            const valor = await getDifferences(DataOnboarding, obj)

            console.log("valor", valor);






            if (isObjectEmpty(valor) && language === 'en') {
                await getInfoUser(6)
                return setPaso(6)
            }
            if (isObjectEmpty(valor) && typeof documentsStep5 === "string") {

                await getInfoUser(6)
                return setPaso(6)

            } else {


                let docstep5URL = null



                if (typeof documentsStep5 !== "string") {

                    docstep5URL = await uploadFile("doc_fund_source", documentsStep5);
                    if (docstep5URL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setdocumentsStep5Error(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (docstep5URL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setdocumentsStep5Error(true)
                        setModalActiveError(true)
                        return
                    }

                }
                if (typeof DocyearStatus !== "string" || typeof byLicensedDoc !== "string") {
                    valor.documents_5 = [];

                }
                if (docstep5URL != null) {

                    await valor.documents_5.push({
                        "code": "doc_fund_source",
                        "url": docstep5URL
                    },);
                }

                fechEditData(valor)
                return
            }


        }
        if (!validateFieldsStep5()) {
            setError(true);
            setErrorMesagge(`${t.validation.incomplete_data}`);
            setLoading(false); // Detener el estado de carga si los campos no son válidos
            return;
        }

        try {
            if (language === "en") {
                await fechDataOnboardingStep5("");
                return
            }
            const ArhivoBrochureURL = await uploadFile("doc_fund_source", documentsStep5);
            if (ArhivoBrochureURL === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setdocumentsStep5Error(true)
                setModalActiveError(true)
                return
            }
            else if (ArhivoBrochureURL === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setdocumentsStep5Error(true)
                setModalActiveError(true)
                return
            }
            await fechDataOnboardingStep5(ArhivoBrochureURL);
        } catch (error) {
            console.error('Error al procesar los datos del paso 5:', error);
            setError(true);
            setErrorMesagge('Ocurrió un error durante el proceso');
        } finally {
            setLoading(false); // Finalizar el estado de carga
        }
    };



    const ConinuarStep6 = async () => {
        setAnimationBack(false)
        setLoading(true); // Comenzar mostrando el estado de carga
        console.log(DataOnboarding);

        if (DataOnboarding !== null) {
            setLoading(true)

            const valor = {}



            if (typeof documents1 === "string" && typeof documents2 === "string" && typeof documents4 === "string" && typeof documents5 === "string") {

                await getInfoUser(7)
                return setPaso(7)

            } else {


                let documents1URL = null
                let documents2URL = null
                let documents3URL = null
                let documents4URL = null
                let documents5URL = null
                let documents6URL = null

                if (documents1 == null || documents2 == null || documents4 == null || documents5 == null) {
                    setError(true);
                    if (documents1 == null) {
                        setDocuments1Error(true)
                    } if (documents2 == null) {
                        setDocuments2Error(true)
                    } if (documents4 == null) {
                        setDocuments4Error(true)
                    } if (documents5 == null) {
                        setDocuments5Error(true)
                    }



                    setErrorMesagge(`${t.validation.incomplete_data}`);
                    setLoading(false); // Detener el estado de carga si los campos no son válidos
                    return
                }


                if (typeof documents1 !== "string") {

                    documents1URL = await uploadFile("archivo_buena_conducta", documents1);
                    if (documents1URL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setDocuments1Error(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (documents1URL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setDocuments1Error(true)
                        setModalActiveError(true)
                        return
                    }

                }
                if (typeof documents2 !== "string") {

                    documents2URL = await uploadFile("arhivo_evidencia_domicilio", documents2);
                    if (documents2URL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setDocuments2Error(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (documents2URL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setDocuments2Error(true)
                        setModalActiveError(true)
                        return
                    }

                }

                if (typeof documents4 !== "string") {

                    documents4URL = await uploadFile("archivo_antecedentes_contador", documents4);
                    if (documents4URL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setDocuments4Error(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (documents4URL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setDocuments4Error(true)
                        setModalActiveError(true)
                        return
                    }

                }
                if (typeof documents5 !== "string") {

                    documents5URL = await uploadFile("archivo_tarjeta_profesional", documents5);
                    if (documents5URL === "Archivo demasiado grande") {
                        setTitle(`${t.modal_alert_pdf_large.title}`);
                        setDescripcion(`${t.modal_alert_pdf_large.description}`);
                        setDocuments5Error(true)
                        setModalActiveError(true)
                        return
                    }
                    else if (documents5URL === "no se pudo subir el archivo") {
                        setTitle(`${t.modal_alert_pdf_error.title}`);
                        setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                        setDocuments5Error(true)
                        setModalActiveError(true)
                        return
                    }

                }

                if (typeof DocyearStatus !== "string" || typeof byLicensedDoc !== "string") {
                    valor.documents_6 = [];

                }
                if (documents1URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_good_conduite",
                        "url": documents1URL
                    },);
                }
                if (documents2URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_company_domicile",
                        "url": documents2URL
                    },);
                }
                if (documents3URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_shareholder_passport",
                        "url": documents3URL
                    },);
                }
                if (documents4URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_accountant_background",
                        "url": documents4URL
                    },);
                }
                if (documents5URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_accountant_card",
                        "url": documents5URL
                    },);
                }
                if (documents6URL != null) {

                    await valor.documents_6.push({
                        "code": "doc_shareholder_certificate",
                        "url": documents6URL
                    },);
                }

                fechEditData(valor)
                return
            }


        }
        if (!validateFieldsStep6()) {
            setError(true);
            setErrorMesagge(`${t.validation.incomplete_data}`);
            setLoading(false); // Detener el estado de carga si los campos no son válidos
            return;
        }

        try {
            const doc1 = await uploadFile("archivo_buena_conducta", documents1);
            if (doc1 === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setDocuments1Error(true)
                setModalActiveError(true)
                return
            }
            else if (doc1 === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setDocuments1Error(true)
                setModalActiveError(true)
                return
            }


            const doc2 = await uploadFile("arhivo_evidencia_domicilio", documents2);
            if (doc2 === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setDocuments2Error(true)
                setModalActiveError(true)
                return
            }
            else if (doc2 === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setDocuments2Error(true)
                setModalActiveError(true)
                return
            }

            const doc4 = await uploadFile("archivo_antecedentes_contador", documents4);
            if (doc4 === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setDocuments4Error(true)
                setModalActiveError(true)
                return
            }
            else if (doc4 === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setDocuments4Error(true)
                setModalActiveError(true)
                return
            }
            const doc5 = await uploadFile("archivo_tarjeta_profesional", documents5);
            if (doc5 === "Archivo demasiado grande") {
                setTitle(`${t.modal_alert_pdf_large.title}`);
                setDescripcion(`${t.modal_alert_pdf_large.description}`);
                setDocuments5Error(true)
                setModalActiveError(true)
                return
            }
            else if (doc5 === "no se pudo subir el archivo") {
                setTitle(`${t.modal_alert_pdf_error.title}`);
                setDescripcion("Hubo un problema al intentar subir el archivo. Por favor, verifica los detalles y vuelve a intentarlo.");
                setDocuments5Error(true)
                setModalActiveError(true)
                return
            }


            await fechDataOnboardingStep6(doc1, doc2, doc4, doc5,);
        } catch (error) {
            console.error('Error durante el proceso del paso 6:', error);
            setError(true);
            setErrorMesagge('Ocurrió un error durante el proceso');
        } finally {
            setLoading(false); // Finalizar el estado de carga
        }
    };

    const validateArray = (array) => {
        console.log(array);

        for (const item of array) {
            // Si `type_person` es 1, valida los campos correspondientes
            if (item.type_person === 1) {
                const fieldsToValidate = [
                    "first_name",
                    "last_name",
                    "type_person",
                    "participation_percentage",
                    "country",
                    "is_pep",
                ];

                for (const field of fieldsToValidate) {
                    if (!item[field] && item[field] !== false) {
                        return false; // Si hay un campo vacío o no definido, retorna false
                    }
                }
            }

            // Si `type_person` es 2, valida los campos correspondientes
            else if (item.type_person === 2) {
                const fieldsToValidate = [
                    "enterprise_legal_name",
                    "enterprise_identification",
                    "type_person",
                    "participation_percentage",
                    "country",
                    "is_pep",
                ];

                for (const field of fieldsToValidate) {
                    if (!item[field] && item[field] !== false) {
                        return false; // Si hay un campo vacío o no definido, retorna false
                    }
                }
            }

            // Si `type_person` no es 1 ni 2, se considera inválido
            else {
                return false;
            }
        }

        return true; // Si pasa todas las validaciones, retorna true
    };



    const userdetails = async () => {

        const response = await axios.post(`/api/user`, {
            headers: await getAuthenticatedHeaders(),
        })
        setDetailLevelUser(response.data.data.level)



    }
    const onClickPaso3 = async () => {
        await getInfoUser(3)
        setPaso(3)
    }
    const onClickPaso4 = async () => {
        await getInfoUser(4)
        setPaso(4)

    }


    useEffect(() => {
        getStepInfo()
        localStorage.setItem("paso", JSON.stringify(paso));
        if (paso === 1) {
            ListCountrys()
            ListSate()

        }
        else if (paso === 2) {
            ListCountrys()
            ListCategory()
            ListRangeSalary()
        }
        else if (paso === 3) {

            ListCountrys()
            BecomeDataFetch()
            BecomeDataStatysFetch()
        }
        else if (paso === 4) {
            fechDataOnboardingShareholdersStatus()
            ListCountrys()
        }
        else if (paso === 5) {


        }

        else if (paso === 6) {

        } else if (paso === 7) {
            fechDataOnboardingShareholdersStatus()
            userdetails()
        }

        if (paso === 3) {


            const intervalId = setInterval(() => BecomeDataStatysFetch("id"), 45000); // 45000 ms = 45 segundos

            return () => clearInterval(intervalId);
        }
        if (paso === 4) {



        }





    }, [paso])
    useEffect(() => {
        getInfoUser()


    }, []);


    useEffect(() => {

        if (typeof countryState === "string") {
            return
        } if (countryState != null) {

            ListSatecities()
        }


    }, [countryState])





    const findUrlByCode = (obj, code) => {
        const document = obj.find(doc => doc.code === code);
        return document ? document.url : null;
    };

    useEffect(() => {
        if (DataOnboarding != null) {


            if (paso === 1) {
                setEnterPriseLegaName(DataOnboarding.enterprise_lega_name)
                setEnterpriseIdentification(DataOnboarding.enterprise_identification)
                setCreationDate(DataOnboarding.creation_date)
                setCountryRegistered(DataOnboarding.country_registered)
                setWebsite(DataOnboarding.website)
                setCity(DataOnboarding.city_state?.name)
                setCountryState(DataOnboarding.state?.name)
                setPhoneNumber(DataOnboarding.phone_number)
                setPhoneNumberCode(language == "es" ? '+57' : "+1")
                setAddress(DataOnboarding.address)
                setEnterpriseDescription(DataOnboarding.enterprise_description)
                setArhivoSociedad(findUrlByCode(DataOnboarding.documents_step_1, "doc_company_incorporation"))
                setArhivoTributario(findUrlByCode(DataOnboarding.documents_step_1, "doc_tax_registry"))
                setArhivoMercantil(findUrlByCode(DataOnboarding.documents_step_1, "doc_commercial_registry"))
                setArhivoBrochure(findUrlByCode(DataOnboarding.documents_step_1, "doc_company_brochure"))
            } else if (paso === 2) {


                setCategoryId(DataOnboarding.category)
                setCategoryDescription(DataOnboarding.category_description)

                setMonthlyIncomeId(DataOnboarding.monthly_income)
                setMonthlyExpensesId(DataOnboarding.monthly_expenses)
                setTotalAssetId(DataOnboarding.total_asset)
                setTotalLiabilityId(DataOnboarding.total_liability)
                setTotalEquityId(DataOnboarding.total_equity)
                setTaxCountry(DataOnboarding.tax_country)
                seThaveOtherIncome(DataOnboarding.have_other_income == null ? false : DataOnboarding.have_other_income)
                sethaveInternationalTransaction(DataOnboarding.have_international_transaction)
                sethaveAml(DataOnboarding.have_aml)
                sethaveComplianceOfficer(DataOnboarding.have_compliance_officer)
                setByLicensed(DataOnboarding.by_licensed)
                sethaveVirtualAsset(DataOnboarding.have_virtual_asset)
                setDocyearStatus(findUrlByCode(DataOnboarding.documents_step_2, "doc_financial_statement"))
                setByLicensedDoc(findUrlByCode(DataOnboarding.documents_step_2, "doc_license") === null ? "" : findUrlByCode(DataOnboarding.documents_step_2, "doc_license"))


                setotherIncomeId(DataOnboarding.other_income)
                setOtherIncomeDescription(DataOnboarding.other_income_description)
                if (DataOnboarding.international_transactions.length != 0) {

                    sethaveInternationalTransactionCountry(DataOnboarding.international_transactions[0].country_transaction)
                    sethaveInternationalTransactionNumber(DataOnboarding.international_transactions[0].international_number_product)
                    sethaveInternationalTransactionEntidad(DataOnboarding.international_transactions[0].entity)
                    sethaveInternationalTransactionRango(DataOnboarding.international_transactions[0].transaction_amount)
                } else {
                    sethaveInternationalTransactionCountry(null)
                    sethaveInternationalTransactionNumber(null)
                    sethaveInternationalTransactionEntidad(null)
                    sethaveInternationalTransactionRango(null)
                }



            } else if (paso === 3) {
                setdocumentNumberLegal(DataOnboarding.document_number_legal)
                setameLegal(DataOnboarding.name_legal)
                setlastNameLegal(DataOnboarding.last_name_legal)
                setcountryLegalName(DataOnboarding.country_legal_name)
                setdomicileState(DataOnboarding.domicile_state)
                setdomicileCity(DataOnboarding.domicile_city)
                setdomicileAddress(DataOnboarding.domicile_address)
                setdomicileDetail(DataOnboarding.domicile_detail)
                setemailLegalAgent(DataOnboarding.email_legal_agent)
                setphoneLegalAgentCode(DataOnboarding.phone_country_code_legal_agent)
                setphoneLegalAgent(DataOnboarding.phone_legal_agent)
                setisPep(DataOnboarding.is_pep)
                setpublicCharge(DataOnboarding.public_charge)
                setdetailCharge(DataOnboarding.detail_charge)

                setdocumentPP(findUrlByCode(DataOnboarding.documents_step_3, "doc_passport_representant"))

            } else if (paso === 4) {

            } else if (paso === 5) {
                setoriginFund(DataOnboarding.origin_fund)
                sethaveExtraFund(DataOnboarding.have_extra_fund)
                setdocumentsStep5(findUrlByCode(DataOnboarding.documents_step_5, "doc_fund_source"))
                setTermAndConditionDate(true)

            } else if (paso === 6) {
                setDocuments1(findUrlByCode(DataOnboarding.documents_step_6, "doc_good_conduite"))
                setDocuments2(findUrlByCode(DataOnboarding.documents_step_6, "doc_company_domicile"))

                setDocuments4(findUrlByCode(DataOnboarding.documents_step_6, "doc_accountant_background"))
                setDocuments5(findUrlByCode(DataOnboarding.documents_step_6, "doc_accountant_card"))

            } else if (paso === 7) {

            }
        }

    }, [DataOnboarding])
    useEffect(() => {
        if (paso == 3) {

            const countdown = setInterval(() => {
                setTimer((prev) => (prev > 0 ? prev - 1 : 45)); // Reinicia a 45 si llega a 0
            }, 1000);

            return () => clearInterval(countdown);
        }
    }, []);

    const AlertContinue = () => {
        if (paso == 3) {
            if (documentPPError) {
                setModalActiveError(false)
                return
            }
            setModalActiveError(false)
            ConinuarStep3()
        } else if (paso == 4) {
            setModalActiveError(false)
            ConinuarStep4()
        } else {
            setModalActiveError(false)
        }
    }

    useEffect(() => {


        if (DetailUser.document_status === "APPROVED") {

            navigate("/splash", { state: { DetailUser: DetailUser } })
        }
        // Detectar si es un refresh
        if (!sessionStorage.getItem("visited")) {
            // Primera vez o navegación normal
            sessionStorage.setItem("visited", "true");
        } else {
            // Es un refresh
            setIsRefreshed(true);
        }
    }, [])

    const fechDataStatus = async (idFinal) => {


        await axios
            .post(`/verify_identity_shareholder/status`, { id: idFinal })
            .then((response) => {
                if (response.data.status === 200) {

                }
            })
            .catch((error) => { });
        setLoading(false);
    };

    const changeStep = (x) => {
        setIsMenuOpen(false); // Cerrar el menú al seleccionar un paso
        if (x == 1) {
            BackSteps2()
        } else if (x == 2) {
            BackSteps3()
        } else if (x == 3) {
            BackSteps4()
        } else if (x == 4) {
            BackSteps5()
        } else if (x == 5) {
            BackSteps6()
        } else if (x == 6) {
            BackSteps7()
        } else if (x == 7) {
            setPaso(7)
        }
    }

    return (
        <div className="w-full h-screen px-4 md:px-8 pt-6 flex flex-col" style={{ background: ColorsMain.bgMain }}>
            <div className="relative flex justify-end items-center h-12">
                <NavbarRegistro onClose={logout} />
            </div>

            {/* Botón de menú hamburguesa - Solo visible en móvil y cuando el menú está cerrado */}
            {!isMenuOpen && (
                <button
                    onClick={toggleMenu}
                    className="md:hidden fixed top-6 left-4 z-50 p-2.5 rounded-lg bg-[#26262D] text-white hover:bg-[#2f2f36] transition-colors duration-200"
                    style={{
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                    }}
                >
                    <Menu size={20} />
                </button>
            )}

            <div className='flex w-full h-full overflow-hidden'>
                {/* Overlay oscuro cuando el menú está abierto en móvil */}
                {isMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
                        onClick={toggleMenu}
                    />
                )}

                {/* Sidebar de pasos - Oculto en móvil, visible como overlay al pulsar menú */}
                <div className={`fixed top-0 left-0 h-screen md:static md:block md:w-4/12 lg:w-3/12 transition-all duration-300 ease-in-out z-40
                    ${isMenuOpen ? 'w-[85%] sm:w-[70%] md:w-4/12 translate-x-0' : 'w-[85%] sm:w-[70%] md:w-4/12 -translate-x-full md:translate-x-0'}`}
                >
                    <div className="h-full">
                        <StepProgress
                            loading={loading}
                            onClickFinal={BecomeDataStatysFetcha}
                            paso={paso}
                            setPaso={setPaso}
                            StepProgress={ProgressStep}
                            changeStep={(e) => changeStep(e)}
                        />
                    </div>
                </div>

                {/* Sección de contenido con scroll */}
                <div className='w-full h-full overflow-y-auto flex flex-col md:flex-row'>
                    <div className='hidden md:block md:w-2/12 lg:w-3/12'></div>
                    <div className='w-full md:w-8/12 lg:w-6/12 h-full px-4 md:px-8'>
                        {ModalActive && <ModalAlert title={title} description={description} onClick={ActiveModalBack} onClickBack={CloseModal} labelButtonWhite={labelModalWhite} />}
                        {ModalActiveError && <ModalAlert title={title} description={description} onClick={() => AlertContinue()} labelButtonWhite={t.modal_alert_kyc.label_button_next} />}



                        {paso === 1 &&
                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >
                                <Step1
                                    LoadingBack={LoadingBack}
                                    LoadingLayouts={LoadingLayouts}
                                    /* manejo de errores */
                                    error={error}
                                    listCities={listCities}
                                    ListaState={ListaState}
                                    errorMesagge={errorMesagge}
                                    enterpriseLegaNameError={enterpriseLegaNameError}
                                    enterpriseLegaNameReadOnly={enterpriseLegaNameReadOnly}
                                    isCompanyPrivateError={isCompanyPrivateError}
                                    isCompanyPrivateReadOnly={isCompanyPrivateReadOnly}
                                    enterpriseIdentificationError={enterpriseIdentificationError}
                                    enterpriseIdentificationReadOnly={enterpriseIdentificationReadOnly}
                                    creationDateError={creationDateError}
                                    countryRegisteredError={countryRegisteredError}
                                    countryRegisteredReadOnly={countryRegisteredReadOnly}
                                    websiteError={websiteError}
                                    websiteReadOnly={websiteReadOnly}
                                    cityError={cityError}
                                    cityReadOnly={cityReadOnly}
                                    countryStateError={countryStateError}
                                    countryStateReadOnly={countryStateReadOnly}
                                    phoneNumberError={phoneNumberError}
                                    phoneNumberReadOnly={phoneNumberReadOnly}
                                    phoneNumberCodeError={phoneNumberCodeError}
                                    phoneNumberCodeReadOnly={phoneNumberCodeReadOnly}
                                    addressError={addressError}
                                    addressReadOnly={addressReadOnly}
                                    enterpriseDescriptionError={enterpriseDescriptionError}
                                    enterpriseDescriptionReadOnly={enterpriseDescriptionReadOnly}
                                    ArhivoSociedadError={ArhivoSociedadError}
                                    ArhivoSociedadReadOnly={ArhivoSociedadReadOnly}
                                    ArhivoTributarioError={ArhivoTributarioError}
                                    ArhivoTributarioReadOnly={ArhivoTributarioReadOnly}
                                    ArhivoMercantilError={ArhivoMercantilError}
                                    ArhivoMercantilReadOnly={ArhivoMercantilReadOnly}
                                    ArhivoBrochureError={ArhivoBrochureError}
                                    ArhivoBrochureReadOnly={ArhivoBrochureReadOnly}
                                    documents_step_1Error={documents_step_1Error}
                                    documents_step_1ReadOnly={documents_step_1ReadOnly}
                                    creationDateReadOnly={creationDateReadOnly}
                                    loading={loading}
                                    /* variables de los inputs */
                                    ArhivoBrochure={ArhivoBrochure}
                                    ArhivoMercantil={ArhivoMercantil}
                                    ArhivoTributario={ArhivoTributario}
                                    ArhivoSociedad={ArhivoSociedad}
                                    setArhivoBrochure={setArhivoBrochure}
                                    setArhivoMercantil={setArhivoMercantil}
                                    onClick={ConinuarStep1}
                                    setArhivoSociedad={setArhivoSociedad}
                                    setArhivoTributario={setArhivoTributario}
                                    phoneNumberCode={phoneNumberCode}
                                    setPhoneNumberCode={setPhoneNumberCode}
                                    enterpriseIdentification={enterpriseIdentification}
                                    setEnterpriseIdentification={setEnterpriseIdentification}
                                    ListCountry={ListCountry}
                                    documents_step_1={documents_step_1}
                                    enterpriseDescription={enterpriseDescription}
                                    website={website} phoneNumber={phoneNumber}
                                    address={address}
                                    city={city}
                                    countryState={countryState}
                                    countryRegistered={countryRegistered}
                                    creationDate={creationDate}
                                    isCompanyPrivate={isCompanyPrivate}
                                    enterpriseLegaName={enterpriseLegaName}
                                    setEnterPriseLegaName={setEnterPriseLegaName}
                                    setIsCompanyPrivate={setIsCompanyPrivate}
                                    setCreationDate={setCreationDate}
                                    setCountryRegistered={setCountryRegistered}
                                    setCountryState={setCountryState}
                                    setAddress={setAddress}
                                    setCity={setCity}
                                    setPhoneNumber={setPhoneNumber}
                                    setWebsite={setWebsite}
                                    setEnterpriseDescription={setEnterpriseDescription}
                                    setDocuments_step_1={setDocuments_step_1} />

                            </motion.div>

                        }
                        {console.log("isRefreshed", isRefreshed)
                        }
                        {paso === 2 && <motion.div

                            initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                            animate={{ x: 0, opacity: 1, scale: 1, }}
                            transition={{ duration: 1, ease: "easeOut" }}

                        >
                            <Step2
                                LoadingBack={LoadingBack}
                                LoadingLayouts={LoadingLayouts}
                                /* Manejo de errores */
                                error={error}
                                errorMesagge={errorMesagge}
                                onClickBack={BackSteps2}
                                loading={loading}
                                categoryIdError={categoryIdError}
                                categoryIdReadOnly={categoryIdReadOnly}
                                categoryDescriptionError={categoryDescriptionError}
                                categoryDescriptionReadOnly={categoryDescriptionReadOnly}
                                monthlyIncomeIdError={monthlyIncomeIdError}
                                monthlyIncomeIdReadOnly={monthlyIncomeIdReadOnly}
                                monthlyExpensesIdError={monthlyExpensesIdError}
                                monthlyExpensesIdReadOnly={monthlyExpensesIdReadOnly}
                                totalAssetIdError={totalAssetIdError}
                                totalAssetIdReadOnly={totalAssetIdReadOnly}
                                totalLiabilityIdError={totalLiabilityIdError}
                                totalLiabilityIdReadOnly={totalLiabilityIdReadOnly}
                                totalEquityIdError={totalEquityIdError}
                                totalEquityIdReadOnly={totalEquityIdReadOnly}
                                taxCountryError={taxCountryError}
                                taxCountryReadOnly={taxCountryReadOnly}
                                haveOtherIncomeError={haveOtherIncomeError}
                                haveOtherIncomeReadOnly={haveOtherIncomeReadOnly}
                                otherIncomeDescriptionError={otherIncomeDescriptionError}
                                otherIncomeDescriptionReadOnly={otherIncomeDescriptionReadOnly}
                                otherIncomeIdError={otherIncomeIdError}
                                otherIncomeIdReadOnly={otherIncomeIdReadOnly}
                                haveInternationalTransactionError={haveInternationalTransactionError}
                                haveInternationalTransactionReadOnly={haveInternationalTransactionReadOnly}
                                DocyearStatusError={DocyearStatusError}
                                DocyearStatusReadOnly={DocyearStatusReadOnly}
                                haveInternationalTransactionCountryError={haveInternationalTransactionCountryError}
                                haveInternationalTransactionCountryReadOnly={haveInternationalTransactionCountryReadOnly}
                                haveInternationalTransactionNumberError={haveInternationalTransactionNumberError}
                                haveInternationalTransactionNumberReadOnly={haveInternationalTransactionNumberReadOnly}
                                haveInternationalTransactionEntidadError={haveInternationalTransactionEntidadError}
                                haveInternationalTransactionEntidadReadOnly={haveInternationalTransactionEntidadReadOnly}
                                haveInternationalTransactionRangoError={haveInternationalTransactionRangoError}
                                haveInternationalTransactionRangoReadOnly={haveInternationalTransactionRangoReadOnly}
                                haveAmlError={haveAmlError}
                                haveAmlReadOnly={haveAmlReadOnly}
                                byLicensedError={byLicensedError}
                                byLicensedReadOnly={byLicensedReadOnly}
                                byLicensedDocReadOnly={byLicensedDocReadOnly}
                                haveComplianceOfficerError={haveComplianceOfficerError}
                                haveComplianceOfficerReadOnly={haveComplianceOfficerReadOnly}
                                haveVirtualAssetError={haveVirtualAssetError}
                                haveVirtualAssetReadOnly={haveVirtualAssetReadOnly}
                                internationalTransactionsError={internationalTransactionsError}
                                internationalTransactionsReadOnly={internationalTransactionsReadOnly}
                                documentsStep2Error={documentsStep2Error}
                                documentsStep2ReadOnly={documentsStep2ReadOnly}
                                byLicensedDocError={byLicensedDocError}

                                /* variables de los inputs */
                                onClick={ConinuarStep2}
                                DocyearStatus={DocyearStatus}
                                setDocyearStatus={setDocyearStatus}
                                sethaveInternationalTransactionRango={sethaveInternationalTransactionRango}
                                haveInternationalTransactionRango={haveInternationalTransactionRango}
                                sethaveInternationalTransactionEntidad={sethaveInternationalTransactionEntidad}
                                haveInternationalTransactionEntidad={haveInternationalTransactionEntidad}
                                sethaveInternationalTransactionNumber={sethaveInternationalTransactionNumber}
                                haveInternationalTransactionNumber={haveInternationalTransactionNumber}
                                sethaveInternationalTransactionCountry={sethaveInternationalTransactionCountry}
                                haveInternationalTransactionCountry={haveInternationalTransactionCountry}
                                byLicensedDoc={byLicensedDoc} setByLicensedDoc={setByLicensedDoc}
                                listCategory={listCategory}
                                ListRange={ListRange}
                                ListCountry={ListCountry}
                                documentsStep2={documentsStep2}
                                internationalTransactions={internationalTransactions}
                                haveVirtualAsset={haveVirtualAsset}
                                byLicensed={byLicensed}
                                haveAml={haveAml}
                                haveComplianceOfficer={haveComplianceOfficer}
                                haveInternationalTransaction={haveInternationalTransaction}
                                otherIncomeId={otherIncomeId}
                                otherIncomeDescription={otherIncomeDescription}
                                haveOtherIncome={haveOtherIncome}
                                taxCountry={taxCountry}
                                totalEquityId={totalEquityId}
                                totalLiabilityId={totalLiabilityId}
                                totalAssetId={totalAssetId}
                                monthlyExpensesId={monthlyExpensesId}
                                monthlyIncomeId={monthlyIncomeId}
                                categoryDescription={categoryDescription}
                                categoryId={categoryId}
                                setCategoryId={setCategoryId}
                                setCategoryDescription={setCategoryDescription}
                                setMonthlyIncomeId={setMonthlyIncomeId}
                                setMonthlyExpensesId={setMonthlyExpensesId}
                                setTotalAssetId={setTotalAssetId}
                                setTotalLiabilityId={setTotalLiabilityId}
                                setTotalEquityId={setTotalEquityId}
                                setTaxCountry={setTaxCountry}
                                seThaveOtherIncome={seThaveOtherIncome}
                                setOtherIncomeDescription={setOtherIncomeDescription}
                                setotherIncomeId={setotherIncomeId}
                                sethaveInternationalTransaction={sethaveInternationalTransaction}
                                sethaveAml={sethaveAml}
                                setByLicensed={setByLicensed}
                                sethaveComplianceOfficer={sethaveComplianceOfficer}
                                sethaveVirtualAsset={sethaveVirtualAsset}
                                setinternationalTransactions={setinternationalTransactions}
                                setdocumentsStep2={setdocumentsStep2} />
                        </motion.div>

                        }

                        {paso === 3 &&
                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >

                                <Step3
                                    LoadingLayouts={LoadingLayouts}

                                    copied={copied}
                                    timer={timer}
                                    LoadingBack={LoadingBack}
                                    /* manejo de errores */
                                    loading={loading}
                                    errorMesagge={errorMesagge}
                                    onClickBack={BackSteps3}
                                    documentTypeLegalError={documentTypeLegalError}

                                    documentNumberLegalError={documentNumberLegalError}
                                    nameLegalError={nameLegalError}
                                    lastNameLegalError={lastNameLegalError}
                                    countryLegalNameError={countryLegalNameError}
                                    domicileStateError={domicileStateError}
                                    domicileCityError={domicileCityError}
                                    domicileAddressError={domicileAddressError}
                                    domicileDetailError={domicileDetailError}
                                    emailLegalAgentError={emailLegalAgentError}
                                    phoneLegalAgentError={phoneLegalAgentError}
                                    phoneLegalAgentCodeError={phoneLegalAgentCodeError}
                                    documentPPError={documentPPError}
                                    isPepError={isPepError}
                                    publicChargeError={publicChargeError}
                                    detailChargeError={detailChargeError}
                                    managepublicResourceError={managepublicResourceError}
                                    documentsSteP3Error={documentsSteP3Error}

                                    /* variables de los inputs */
                                    id={DetailUser.id}
                                    name={DetailUser.first_name}
                                    copyToClipboard={copyToClipboard}
                                    LoadingKYC={LoadingKYC}
                                    phoneLegalAgentCode={phoneLegalAgentCode}
                                    setphoneLegalAgentCode={setphoneLegalAgentCode}
                                    ListCountry={ListCountry}


                                    onClick={alertConitnue3}
                                    becomeData={becomeData}
                                    LevelKYC={LevelKYC}
                                    BecomeDataStatysFetch={() => BecomeDataStatysFetch()}
                                    documentTypeLegal={documentTypeLegal}
                                    setdocumentTypeLegal={setdocumentTypeLegal}
                                    documentNumberLegal={documentNumberLegal}
                                    setdocumentNumberLegal={setdocumentNumberLegal}
                                    nameLegal={nameLegal}
                                    setameLegal={setameLegal}
                                    lastNameLegal={lastNameLegal}
                                    setlastNameLegal={setlastNameLegal}
                                    countryLegalName={countryLegalName}
                                    setcountryLegalName={setcountryLegalName}
                                    domicileState={domicileState}
                                    setdomicileState={setdomicileState}
                                    domicileCity={domicileCity}
                                    setdomicileCity={setdomicileCity}
                                    domicileAddress={domicileAddress}
                                    setdomicileAddress={setdomicileAddress}
                                    domicileDetail={domicileDetail}
                                    setdomicileDetail={setdomicileDetail}
                                    emailLegalAgent={emailLegalAgent}
                                    setemailLegalAgent={setemailLegalAgent}
                                    phoneLegalAgent={phoneLegalAgent}
                                    setphoneLegalAgent={setphoneLegalAgent}
                                    isPep={isPep}
                                    setisPep={setisPep}
                                    publicCharge={publicCharge}
                                    setpublicCharge={setpublicCharge}
                                    detailCharge={detailCharge}
                                    setdetailCharge={setdetailCharge}
                                    managepublicResource={managepublicResource}
                                    setmanagepublicResource={setmanagepublicResource}
                                    documentsSteP3={documentsSteP3}
                                    setdocumentsSteP3={setdocumentsSteP3}
                                    documentPP={documentPP} setdocumentPP={setdocumentPP}
                                />
                            </motion.div>

                        }

                        {paso === 4 &&
                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >

                                <Step4
                                    LoadingLayouts={LoadingLayouts}

                                    buttonOff={(DataCompany == null || DataCompany.length === 0) ? true : false}
                                    isDisabled={isDisabled}
                                    timer={timer}
                                    copied={copied}
                                    LoadingBack={LoadingBack}
                                    ErrorCompany={ErrorCompany}
                                    LoadingBenefactores={LoadingBenefactores}
                                    /* manejo de errores */
                                    loading={loading}
                                    /* variable de inputs */


                                    onClickBack={BackSteps4}
                                    DataCompany={DataCompany}
                                    save={fechDataOnboardingSaveShareholders}
                                    shareholders={shareholders}
                                    ListCountry={ListCountry}
                                    onClick={alertConitnue4}
                                    copyToClipboard={copyToClipboard}
                                    setShareholders={setShareholders} />
                            </motion.div>

                        }

                        {paso === 5 &&
                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >
                                <Step5
                                    LoadingLayouts={LoadingLayouts}

                                    DataOnboarding={DataOnboarding}
                                    /* manejo de errores */
                                    LoadingBack={LoadingBack}
                                    loading={loading}
                                    error={error}
                                    onClickBack={BackSteps5}
                                    errorMesagge={errorMesagge}
                                    originFundError={originFundError}
                                    haveExtraFundError={haveExtraFundError}
                                    extraFundDetailError={extraFundDetailError}
                                    TermAndConditionDateError={TermAndConditionDateError}
                                    documentsStep5Error={documentsStep5Error}

                                    /* variable de inputs */
                                    setdocumentsStep5={setdocumentsStep5}
                                    documentsStep5={documentsStep5}
                                    TermAndConditionDate={TermAndConditionDate}
                                    extraFundDetail={extraFundDetail}
                                    haveExtraFund={haveExtraFund}
                                    originFund={originFund}
                                    onClick={ConinuarStep5}
                                    setoriginFund={setoriginFund}
                                    sethaveExtraFund={sethaveExtraFund}
                                    setextraFundDetail={setextraFundDetail}
                                    setTermAndConditionDate={setTermAndConditionDate} />
                            </motion.div>

                        }

                        {paso === 6 &&

                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >
                                <Step6
                                    LoadingLayouts={LoadingLayouts}

                                    LoadingBack={LoadingBack}
                                    /* manejo de errores */
                                    loading={loading}
                                    error={error}
                                    errorMesagge={errorMesagge}
                                    documents1Error={documents1Error}
                                    documents2Error={documents2Error}
                                    documents3Error={documents3Error}
                                    documents4Error={documents4Error}
                                    documents5Error={documents5Error}
                                    documents6Error={documents6Error}
                                    documentsStep4Error={documentsStep4Error}
                                    /* variable de inputs */


                                    setDocuments1={setDocuments1}
                                    setDocuments2={setDocuments2}

                                    setDocuments4={setDocuments4}
                                    setDocuments5={setDocuments5}
                                    setDocuments6={setDocuments6}
                                    documents1={documents1}
                                    documents2={documents2}
                                    ProgressStep={ProgressStep}
                                    documents4={documents4}
                                    documents5={documents5}
                                    documents6={documents6}
                                    onClick={ConinuarStep6}
                                    onClickBack={BackSteps6}
                                />
                            </motion.div>
                        }

                        {paso === 7 &&
                            <motion.div
                                initial={isRefreshed ? AnimationBack ? { x: "200%", opacity: 0 } : { x: "-100%", opacity: 0 } : { scale: 0.8, }}
                                animate={{ x: 0, opacity: 1, scale: 1, }}
                                transition={{ duration: 1, ease: "easeOut" }}
                            >

                                <Step7

                                    loading={loading}
                                    onClickBack={BackSteps7}
                                    LoadingBack={LoadingBack}
                                    setPaso={setPaso}
                                    onClickPaso4={onClickPaso4}
                                    onClickPaso3={onClickPaso3}
                                    totalCompany={totalCompany}
                                    companyPending={companyPending}
                                    userlevel={detailLevelUser}
                                    onClick={BecomeDataStatysFetcha} />
                            </motion.div>

                        }
                    </div>

                </div>

            </div>
        </div>
    );
};

export default DocumentationLegal;

